<template>
    <div v-if="userPermissions" class="background" :class="{'pb-1': !show_menu_panel,'menu-transit':show_menu_panel == false || show_menu_panel,'h-58':!show_menu_panel}" style="height: auto !important;min-height: 103px !important;">
        <div class="header">
            <div class="d-flex align-items-center">
                <span v-if="show_menu_panel" class="header-company ml-4">DigiCollect</span>
                <router-link class="product" :class="{'l-0': !show_menu_panel}" :to="{'name': 'HomeDashboard'}" style="text-decoration:none !important;">
                    <span class="product-logo">
                        <!-- <i class="logo-crm"></i> -->
                        <img src="/static/images/crm-logo.png" alt="" width="125px">
                    </span>
                    <!-- <span class="product-name">DigiCRM</span> -->
                </router-link>
            </div>
            <div class="ml-33 animated" :class="{'in-down':show_menu_panel == false || show_menu_panel,'fadeOut': show_menu_panel == false}" v-if="!show_menu_panel">
                <menubar :show_menu_panel="show_menu_panel" @toggleMenuPanel="show_menu_panel = false"></menubar>
            </div>
            <div class="d-flex align-items-center">
                <div class="mr-2 hidden-md-down text-white box-shadow isp-active" :class="{'digi-red': !isp_stable}">
                    ISP 
                </div>
                <!-- <div v-if="show_menu_panel" class="dropdown px-sm-0 mr-2">
                    <div class="dropdown-toggle pointer dropdownhideafter row align-items-center no-gutters text-white box-shadow" role="button" id="dropdownShortcutMenu" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <el-tooltip class="item" effect="dark" content="Notification" placement="top">
                            <img src="https://cdn.digicollect.com/cdn/crm_menu/menus/search.svg" class="w-85">
                        </el-tooltip>
                    </div>
                </div> -->
                <div class="minimize-menu pointer" @click="menuBars('submenu')">
                    <div class="align-items-center">
                        <div class="dots-vertical background-dots">
                            <el-tooltip class="item" effect="dark" content="View More" placement="left">
                                <i class="icon icon-dots-horizontal dots-vertical fs-25 pointer" style="color: #fff;"></i>
                            </el-tooltip>
                        </div>
                    </div>
                </div>
                <div class="user-menu-button hidebuttons">
                    <el-dropdown class="pl-2 pr-0" trigger="click">
                        <span class="el-dropdown-link" @click="ReloadSearch">
                            <div class="d-flex align-items-center">
                                <div class="avatar-wrapper">
                                    <img src="https://cdn.digicollect.com/cdn/crm_menu/menus/search.svg" class="w-85">
                                </div>
                            </div>
                        </span>
                        <el-dropdown-menu slot="dropdown" class="searchBoxNavbar">
                            <div class="search-dropdown px-1 py-3 w-325px w-md-375px">
                                <div>
                                    <form class="w-100 position-relative" autocomplete="off">
                                        <span class="svg-icon svg-icon-2 svg-icon-lg-1 svg-icon-gray-500 position-absolute top-50 translate-middle-y ms-0">
                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <rect opacity="0.5" x="17.0365" y="15.1223" width="8.15546" height="2" rx="1" transform="rotate(45 17.0365 15.1223)" fill="currentColor"></rect>
                                                <path d="M11 19C6.55556 19 3 15.4444 3 11C3 6.55556 6.55556 3 11 3C15.4444 3 19 6.55556 19 11C19 15.4444 15.4444 19 11 19ZM11 5C7.53333 5 5 7.53333 5 11C5 14.4667 7.53333 17 11 17C14.4667 17 17 14.4667 17 11C17 7.53333 14.4667 5 11 5Z" fill="currentColor"></path>
                                            </svg>
                                        </span>
                                        <input type="text" class="search-input form-search-control form-control-flush ps-10" name="search" @input="SearchData" v-model="search_lcc" placeholder="Start your search…" />
                                        <span class="closebtn btn-flush btn-active-color-primary position-absolute top-50 end-0 translate-middle-y lh-0" v-if="search_lcc != ''" @click="search_lcc = ''">
                                            <span class="svg-icon svg-icon-2 svg-icon-lg-1 me-0">
                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)" fill="currentColor"></rect>
                                                    <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)" fill="currentColor"></rect>
                                                </svg>
                                            </span>
                                        </span>
                                    </form>
                                    <div class="separator border-gray-200 mb-1" v-if="searched_lists.length > 0"></div>

                                    <div class="mb-1 scroller" v-if="search_lcc.length" @scroll="infiniteSearchScroll">
                                        <!-- <div class="d-flex flex-stack fw-semibold mb-4">
                                            <span class="text-muted fs-13 me-2">Recently Searched:</span>
                                        </div> -->
                                        <div class="d-flex align-items-center justify-content-center w-100" v-if="loadSearch">
                                            <half-circle-spinner :animation-duration="1000" :size="50" color="#00448b"
                                                style="margin: 0 auto;" />
                                        </div>
                                        <div class="text-center" v-if="!loadSearch && searched_lists.length == 0">
                                            <div class="py-5">
                                                <span class="svg-icon svg-icon-4x opacity-50">
                                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path opacity="0.3" d="M14 2H6C4.89543 2 4 2.89543 4 4V20C4 21.1046 4.89543 22 6 22H18C19.1046 22 20 21.1046 20 20V8L14 2Z" fill="currentColor"></path>
                                                        <path d="M20 8L14 2V6C14 7.10457 14.8954 8 16 8H20Z" fill="currentColor"></path>
                                                        <rect x="13.6993" y="13.6656" width="4.42828" height="1.73089" rx="0.865447" transform="rotate(45 13.6993 13.6656)" fill="currentColor"></rect>
                                                        <path d="M15 12C15 14.2 13.2 16 11 16C8.8 16 7 14.2 7 12C7 9.8 8.8 8 11 8C13.2 8 15 9.8 15 12ZM11 9.6C9.68 9.6 8.6 10.68 8.6 12C8.6 13.32 9.68 14.4 11 14.4C12.32 14.4 13.4 13.32 13.4 12C13.4 10.68 12.32 9.6 11 9.6Z" fill="currentColor"></path>
                                                    </svg>
                                                </span>
                                            </div>
                                            <div class="pb-8 fw-semibold">
                                                <h3 class="text-gray-800 fs-14 mb-1 fw-600">
                                                    No Results Found
                                                </h3>
                                            </div>
                                        </div>
                                        <el-dropdown-item class="search-custom" v-else>
                                            <div class="scroll-y mh-200px mh-lg-325px" @click="RedirectActivityLog(data)" v-for="(data, index) in searched_lists" :key="index" >
                                                <div class="d-flex align-items-center pb-2 pt-2 section-hover borderBottom pointer">
                                                    <div class="imageSymbol imageSymbol-40px me-4">
                                                        <span class="imageSymbol-label">
                                                            <img class="imgAvatar" v-if="data.image" :src="data.image" :alt="data.user_name" />
                                                            <img class="imgAvatar" v-else src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/No%20Picture.svg" :alt="data.user_name" />
                                                        </span>
                                                    </div>
                                                    <div class="d-flex flex-column">
                                                        <a href="javascript:;" class="fs-14 text-gray-800 text-hover-primary fw-semibold text-decoration-none text-truncate mw-300">{{data.user_name}} {{data.company ? `(${data.company})` : ''}}</a>
                                                        <span class="fs-13 text-muted fw-semibold">{{data.type}}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </el-dropdown-item>
                                    </div>
                                </div>
                            </div>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>

                <!-- Notifications Popup start -->

                <div class="pr-0 hidebuttons">
                    <el-dropdown class="pl-2 pr-2" trigger="click">
                        <span class="el-dropdown-link">
                            <div class="d-flex align-items-center">
                                <div class="avatar-wrapper position-relative" @click="getNotificationsClick">
                                    <div class="text-center text-white notification-count" v-if="total_notifications_count > 0">{{total_notifications_count | messageCount}}</div>
                                    <img src="https://cdn.digicollect.com/cdn/scmnew/images/images-new-theme/notification.svg" class="w-85">
                                </div>
                            </div>
                        </span>
                        <el-dropdown-menu slot="dropdown" class="searchBoxNavbar">
                            <div class="d-flex justify-content-between px-1 py-3 w-325px w-md-375px">
                                <div class="lh-24px fs-15 ml-2 fw-500">Notifications ({{total_notifications_count}})</div>
                                <!-- <i class="icon icon-close-circle"></i> -->
                            </div>
                            <div v-if="notifications_list_loading && notifications_list.length <= 0" class="mb-3">
                                <half-circle-spinner :animation-duration="1000" :size="20" color="#00448b" style="margin: 0 auto;" />
                            </div>
                            <div v-if="!notifications_list_loading && notifications_list.length <= 0" class="d-flex justify-content-center align-items-center">
                                <h6>No Notifications Found</h6>
                            </div>
                            <div v-else class="scroller" @scroll="infiniteScroll">
                                <el-dropdown-item class="search-custom-note m-1" @click.native="viewReminder(note)" :class="note.is_read ? 'selected' : ''" v-for="(note, index) in notifications_list" :key="index">
                                    <div class="d-flex justify-content-between align-items-center" style="border-bottom: solid 1px #e4e4e4;">
                                        <div>
                                            <div class="fw-normal fs-14 fw-500 messageText" :title="note.message">{{note.message}}</div>
                                            <div class="fw-normal fs-12">{{note.create_datetime}}</div>
                                        </div>
                                        <div>
                                            <div style="background-color: rgb(0, 68, 139);height: 35px;width: 35px;border-radius: 100%;" class="d-flex">
                                                <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/newcrm/clock_white.svg" v-if="note.img_type == 'follow_up'" class="margin-auto-img" alt="Follow Up" width="15">
                                                <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/newcrm/white-calendar-new.svg" v-if="note.img_type == 'event'" class="margin-auto-img" alt="Event" width="15">
                                                <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/newcrm/megaphone.svg" v-if="note.img_type == 'task'" class="margin-auto-img" alt="Task" width="15">
                                                <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/newcrm/bell_icon.svg" v-if="note.img_type == 'reminder'" class="margin-auto-img" alt="Remainder" width="15">
                                            </div>
                                        </div>
                                    </div>
                                </el-dropdown-item>
                            </div>

                            <div v-if="(ajax_loader && notifications_list.length > 0)" class="d-flex justify-content-center align-items-center notify-loader">
                                <half-circle-spinner :animation-duration="1000" :size="35" color="#00448b" style="margin: 0 auto;" />
                            </div>
                            <el-dropdown-item class="px-0">
                                <div class="d-flex justify-content-between px-3 py-1 w-325px w-md-375px" style="border-top:1px solid #afafaf">
                                    <div class="lh-30px fs-12 fw-600 text-secondary pointer" @click="gotoNotifications">View All Notifications</div>
                                    <div class="lh-30px fs-12 fw-600 pointer text-secondary" v-if="notifications_list.length" @click="MarkAllAsRead">Mark All Read</div>
                                    <div class="lh-30px fs-12 fw-600 text-grey" v-else>Mark All Read</div>
                                </div>
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>

                <!-- Notifications Popup end -->


                <!-- <div class="d-flex align-items-center">
                    <div class="dropdown select-options">
                        <div class="dropdown-toggle pointer dropdownhideafter row align-items-center no-gutters text-white box-shadow searchContentProduct" role="button" id="dropdownShortcutMenu" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <el-tooltip class="item" effect="dark" content="Menu" placement="top">
                                <i class="icon-dots-vertical text-white fs-17"></i>
                            </el-tooltip>
                        </div>
                        <div class="dropdown-menu dropdown-apps pt-2" aria-labelledby="dropdownShortcutMenu" style="top: 15px !important;width:176px !important">
                            <form>
                                <div v-if="show_menu_panel" class="dropdown">
                                    <div class="dropdown-toggle pointer whiteSpace dropdownhideafter pb-2 pt-2 pr-4 row align-items-center no-gutters px-2 ml-1 text-white box-shadow" role="button" id="dropdownShortcutMenu" style="padding-left:1.3rem !important" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        <el-tooltip class="item" effect="dark" content="Notification" placement="top">
                                            <img src="https://cdn.digicollect.com/cdn/scmnew/images/menus/images/notification.svg" style="width:26%;">
                                        </el-tooltip>
                                        <span class="text-black ml-2">Notifications</span>
                                    </div>
                                    <div class="dropdown-menu dropdown-requests" aria-labelledby="dropdownShortcutMenu">
                                        <div class="notificationblock" v-if="!seeRequests">
                                            <div class="notifyheader" style="background-color: #f1f8fc !important;">
                                                <div class="descriptionheader">
                                                    <div class="description-text-header-left">
                                                        <h5>Recent Notifications</h5>
                                                    </div>
                                                    <div class="description-text-header-right"
                                                        @click="seeRequests=!seeRequests;getConnectionRequestsAPI();">
                                                        Manage Requests
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="">
                                                <div class="mb-4">
                                                    <div class="py-1 px-4 notifySearch">
                                                        <div class="row" v-if="ajaxCallinprogress">
                                                            <div class="col-lg-12 py-5 px-3 mt-10">
                                                                <div class="flex-container">
                                                                    <half-circle-spinner :animation-duration="1000" :size="60"
                                                                        color="#fff" />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div v-if="!ajaxCallinprogress && notificationsList.length === 0"
                                                            class="contact row py-4 pointer text-center"
                                                            style="color: #00448b;font-size: 15px;font-weight: 600;margin: 0 auto;display: block;">
                                                            <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/no_notifications.svg"
                                                                class="img-fluid"
                                                                style="width: 100px;display: block;margin: 0 auto;">
                                                            <span class="pt-3">No Notifications Found</span>
                                                        </div>
                                                        <div v-if="!ajaxCallinprogress">
                                                            <div v-for="notification in notificationsList" :key="notification._id"
                                                                @click="notificationRead(notification._id)"
                                                                v-bind:class="{'unread': notification.status=='unread'}">
                                                                <div class="contact row py-2 px-4 pointer m-0"
                                                                    :style="notification.is_read ? 'background-color:rgba(13, 91, 230, 0.16);' : 'background-color: #fff;'">
                                                                    <div class="avatar-wrapper">
                                                                        <img :src="notification.profile_pic||'https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/default.png'"
                                                                            class="avatar" :alt="notification.full_name">
                                                                    </div>
                                                                    <div class="col px-4">
                                                                        <span class="name h6 fs-14">
                                                                            <span class="defaultDarkBlue"
                                                                                @click="goToProfile(notification.sent_by)">{{notification.full_name}}</span>
                                                                            has accepted your Connection Request
                                                                        </span>
                                                                    </div>
                                                                    <div
                                                                        class="col-sm-auto d-flex flex-column align-items-end pr-0 pl-0">
                                                                        <div class="show-message-time fs-12">
                                                                            {{notification.created_time}}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="acceptreject" v-if="seeRequests">
                                            <div class="notifyheader" style="background-color: #f1f8fc !important;">
                                                <div class="descriptionheader">
                                                    <div class="description-text-header-left">
                                                        <h5>Manage Requests</h5>
                                                    </div>
                                                    <div class="description-text-header-right" @click="seeRequests=!seeRequests">
                                                        Recent Notifications
                                                    </div>
                                                </div>
                                            </div>
                                            <ul class="nav nav-tabs nav-fill nav-topbar-tab">
                                                <li class="nav-item">
                                                    <a class="nav-link subnav-tabs" style="border-right: 1.5px solid #cdd2da;"
                                                        href="javascript:;" :class="{'active':contactRequestTab==true}"
                                                        @click="changeModelView('contactTab')">Connection Requests</a>
                                                </li>
                                                <li class="nav-item">
                                                    <a class="nav-link subnav-tabs" href="javascript:;"
                                                        :class="{'active':employeeRequestTab==true}"
                                                        @click="changeModelView('employeeTab')">Employee Requests</a>
                                                </li>
                                            </ul>
                                            <div class="tab-content">
                                                <div class="" role="tabpanel" aria-labelledby="contact-requests-tab"
                                                    v-if="contactRequestTab">
                                                    <div class="">
                                                        <div class="mb-4">
                                                            <div class="py-1 px-4 notifySearch">
                                                                <div class="row" v-if="ajaxCallinprogress">
                                                                    <div class="col-lg-12 py-5 px-3 mt-10">
                                                                        <div class="flex-container">
                                                                            <half-circle-spinner :animation-duration="1000"
                                                                                :size="60" color="#fff" />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div v-if="!ajaxCallinprogress && connectionsList.length === 0"
                                                                    class="contact row py-4 pointer text-center"
                                                                    style="color: #00448b;font-size: 15px;font-weight: 600;margin: 0 auto;display: block;">
                                                                    <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/no_notifications.svg"
                                                                        class="img-fluid"
                                                                        style="width: 100px;display: block;margin: 0 auto;">
                                                                    <span class="pt-3">No Notifications Found</span>
                                                                </div>
                                                                <div v-if="!ajaxCallinprogress">
                                                                    <div v-for="connection in connectionsList"
                                                                        :key="connection._id">
                                                                        <div class="contact row py-1 px-4 pointer mb-0"
                                                                            :style="connection.is_read ? 'background-color:rgba(13, 91, 230, 0.16);' : 'background-color: #fff;'">
                                                                            <div class="avatar-wrapper">
                                                                                <img :src="connection.profile_pic||'https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/default.png'"
                                                                                    class="avatar" :alt="connection.full_name">
                                                                            </div>
                                                                            <div class="col pl-4 pr-2">
                                                                                <span class="name h6 fs-14">
                                                                                    Request from <span class="defaultDarkBlue"
                                                                                        @click="goToProfile(connection.sent_by)"
                                                                                        style="color: #00448b !important;">{{connection.full_name}}</span>
                                                                                    to join their network
                                                                                </span>
                                                                                <div class="name h6 fs-14 d-flex align-items-start">
                                                                                    Message:<span
                                                                                        style="color: #414141 !important; margin-left: 10px;">{{connection.message}}</span>
                                                                                </div>
                                                                                <p class="last-message text-truncate py-1 mb-0">
                                                                                    <button
                                                                                        class="btn btn-new-danger btn-wide mx-4 mb-1"
                                                                                        v-on:click.once="changeStatus('ignore',connection._id,connection.sent_by)">Reject</button>
                                                                                    <button
                                                                                        class="btn btn-new-green btn-wide ml-1 mr-4 mb-1"
                                                                                        v-on:click.once="changeStatus('connected',connection._id,connection.sent_by)">Accept</button>
                                                                                </p>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="" role="tabpanel" aria-labelledby="employee-requests-tab"
                                                    v-if="employeeRequestTab">
                                                    <div class="px-4">
                                                        <div class="mb-4">
                                                            <div class="py-1 px-4 notifySearch">
                                                                <div class="row" v-if="ajaxCallinprogress">
                                                                    <div class="col-lg-12 py-5 px-3 mt-10">
                                                                        <div class="flex-container">
                                                                            <half-circle-spinner :animation-duration="1000"
                                                                                :size="60" color="#fff" />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div v-if="!ajaxCallinprogress && employeeDataCount.length === 0"
                                                                    class="contact row py-4 pointer text-center"
                                                                    style="color: #00448b;font-size: 15px;font-weight: 600;margin: 0 auto;display: block;">
                                                                    <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/no_connection.svg"
                                                                        class="img-fluid"
                                                                        style="width: 100px;display: block;margin: 0 auto;">
                                                                    <span class="pt-3">No Requests Found</span>
                                                                </div>
                                                                <div v-if="!ajaxCallinprogress">
                                                                    <div class="contact row py-1 pointer"
                                                                        v-for="employeeconnection in employeeDataCount"
                                                                        :key="employeeconnection._id">
                                                                        <div class="avatar-wrapper">
                                                                            <img :src="employeeconnection.company.logo||'https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/default.png'"
                                                                                class="avatar"
                                                                                :alt="employeeconnection.company.company_name">
                                                                        </div>
                                                                        <div class="col pl-4 pr-2">
                                                                            <span class="name h6 fs-14">
                                                                                <span
                                                                                    class="defaultDarkBlue">{{employeeconnection.company.company_name}}</span><br>
                                                                                invited by <span
                                                                                    class="text-secondary">{{employeeconnection.invited_by.full_name}}</span>
                                                                            </span>
                                                                            <p class="last-message text-truncate py-1 mb-0">
                                                                                <a class="btn btn-new-primary btn-smm ml-1 mr-4 mb-1"
                                                                                    v-on:click.once="changeEmployeeStatus('active',employeeconnection._id)">Accept</a>
                                                                                <a class="btn btn-new-darkdanger btn-smm mx-4 mb-1"
                                                                                    v-on:click.once="changeEmployeeStatus('ignore',employeeconnection._id)">Reject</a>
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                    <div v-if="show_menu_panel" class="dropdown px-sm-0 mr-2">
                        <div class="dropdown-toggle pointer nav-options dropdownhideafter row align-items-center no-gutters ml-1 text-white box-shadow" role="button" id="dropdownShortcutMenu" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <el-tooltip class="item" effect="dark" content="Notification" placement="top">
                                <img src="https://cdn.digicollect.com/cdn/crm_menu/menus/search.svg" class="w-85">
                            </el-tooltip>
                        </div>
                    </div>
                    <div v-if="show_menu_panel" class="dropdown px-sm-0 mr-2">
                        <div class="dropdown-toggle pointer nav-options dropdownhideafter row align-items-center no-gutters text-white box-shadow" role="button" id="dropdownShortcutMenu" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <el-tooltip class="item" effect="dark" content="Notification" placement="top">
                                <img src="https://cdn.digicollect.com/cdn/scmnew/images/menus/images/notification.svg" class="w-85">
                            </el-tooltip>
                        </div>
                    </div>
                </div> -->
                <div v-if="show_menu_panel" class="dropdown px-sm-0 mr-1 hidebuttons">
                    <div class="dropdown-toggle pointer dropdownhideafter row align-items-center no-gutters text-white box-shadow" role="button" id="dropdownShortcutMenu" @click="showProductList" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <el-tooltip class="item" effect="dark" content="Products" placement="top">
                            <img src="https://cdn.digicollect.com/cdn/scmnew/images/menus/images/products.svg" class="w-85">
                        </el-tooltip>
                    </div>
                    <product-dropdown></product-dropdown>
                </div>
                <div v-if="show_menu_panel" class="language-button hidebuttons dropdown timezone-button d-none d-md-block hidden-md-down">
                    <div class="dropdown-toggle row align-items-center justify-content-center no-gutters px-0 px-sm-4 btn btn-icon text-white products-button" role="button" id="dropdownLanguageMenu" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <div class="row no-gutters align-items-center justify-content-center font-weight-bold">
                            <span class="text-white" v-if = "guess" >
                                {{timeDefault}}
                            </span>
                            <span class="text-white" v-else-if = "newyork">
                                {{timeNewYork}}
                            </span>
                            <span class="text-white" v-else-if = "london">
                                {{timeLondon}}
                            </span>
                            <span class="text-white" v-else-if = "kolkata">
                                {{timeKolkata}}
                            </span>
                            <span class="text-white" v-else-if = "singapore">
                                {{timeSingapore}} SGT
                            </span>
                            <span class="text-white" v-else-if = "yangon">
                                {{timeYangon}} MMT
                            </span>
                            <span class="text-white" v-else-if = "bangkok">
                                {{timeThailand}} ICT
                            </span>
                        </div>
                    </div>
                    <div class="dropdown-menu dropdown-time timezone" aria-labelledby="dropdownLanguageMenu">
                        <a class="dropdown-item" href="#">
                            <div class="row no-gutters align-items-center flex-nowrap">
                                <span class="px-3" v-on:click = ' guess = false, newyork = true, london=false, kolkata=false, singapore=false, bangkok=false, yangon=false'>{{timeNewYork}}</span>
                            </div>
                        </a>
                        <a class="dropdown-item" href="#">
                            <div class="row no-gutters align-items-center flex-nowrap">
                                <span class="px-3"  v-on:click = ' guess = false, newyork = false, london=true, kolkata=false, singapore=false, bangkok=false, yangon=false'>{{timeLondon}}</span>
                            </div>
                        </a>
                        <a class="dropdown-item" href="#">
                            <div class="row no-gutters align-items-center flex-nowrap">
                                <span class="px-3" v-on:click = ' guess = false, newyork = false, london=false, kolkata=true, singapore=false, bangkok=false, yangon=false'>{{timeKolkata}}</span>
                            </div>
                        </a>
                        <a class="dropdown-item" href="#">
                            <div class="row no-gutters align-items-center flex-nowrap">
                                <span class="px-3" v-on:click = ' guess = false, newyork = false, london=false, kolkata=false, singapore=true, bangkok=false, yangon=false'>{{timeSingapore}} SGT</span>
                            </div>
                        </a>
                        <a class="dropdown-item" href="#">
                            <div class="row no-gutters align-items-center flex-nowrap">
                                <span class="px-3"  v-on:click = ' guess = false, newyork = false, london=false, kolkata=false, singapore=false, bangkok=false, yangon=true'>{{timeYangon}} MMT</span>
                            </div>
                        </a>
                        <a class="dropdown-item" href="#">
                            <div class="row no-gutters align-items-center flex-nowrap">
                                <span class="px-3"  v-on:click = ' guess = false, newyork = false, london=false, kolkata=false, singapore=false, yangon=false, bangkok=true'>{{timeThailand}} ICT</span>
                            </div>
                        </a>
                    </div>
                </div>
                <div class="user-menu-button" >
                    <div class="pl-3 pr-2 position-relative">
                        <span class="pointer" @click="showHideCompSwitchDropdown">
                            <div class="d-flex align-items-center" style="background-color: #fff; height: 35px; border-radius: 5px;">

                                <span class="username mx-3 d-none d-md-block text-truncate"
                                    style="font-size: 14px;padding-top:2px;max-width:100px;color: #00448b;"
                                    :title="loggedInUser.full_name">
                                        {{loggedInUser.full_name}}
                                </span>
                                <div class="avatar-wrapper pr-2 avtr-padding">
                                    <img class="avatar"
                                        :src="loggedInUser.profile_pic || 'https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/default.png'" />
                                </div>
                                <!-- <i class="icon icon-chevron-down text-white"></i> -->
                            </div>
                        </span>
                        <div v-if="show_hide_comp_switch_dropdown" @click="onBlurHideCompSwitch" class="switch-company-backdrop">
                        </div>
                        <div v-if="show_hide_comp_switch_dropdown" class="admin-width">
                            <div v-if="user_company.organization_name">
                                <div style="text-align: center;" class="my-3">
                                    <span class="fw-600 fs-12"> This account is managed by {{user_company.organization_name}}</span>
                                </div>
                            </div>
                            <div class="dropdown-width-responsive">
                                <div class="pt-3">
                                    <hr>
                                    <div class="d-flex align-items-start w-100 pt-2 pb-0">
                                        <div class="switch-user-prpfile ml-4">
                                            <img style="border-radius: 50%; border: 2px solid #ecf1f9;" :src="loggedInUser.profile_pic || 'https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/default.png'" width="70" height="70" />
                                            <div class="col-1 hide-on-mob-screen">
                                                <div class="pointer btn-size">
                                                    <button class="btn btn-secondary btn-smm" @click="logout()">
                                                        Logout
                                                    </button>
                                                </div>
                                                <div class="settings-icon pointer setting-align" @click="goToSettings">
                                                    <img width="18" src="https://testcrm.digicollect.com/static/images/images-new-theme/icons/settings-new-right.svg"/>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="w-100 pl-2">
                                            <div class="text-secondary fs-14 pl-2 pt-2 pr-4">
                                                <span class="fw-800 text-capitalize"
                                                    :title="loggedInUser.full_name">{{loggedInUser.full_name}}</span>
                                                <span class="ml-1 text-gray fw-600 text-capitalize" style="color: #3f3f3f;">({{loggedInUser.user_role_name.replaceAll('_',' ')}})</span>
                                            </div>
                                            <div class="d-flex main-dropdown justify-content-between pointer pl-2 pr-4 background-default">
                                                <!-- <div class="mt-0">
                                                    <h1 v-if="user_company.organization_name" class="fs-14 text-gray mb-0 text-capitalize">{{user_company.organization_name}}</h1>
                                                    <h1 v-if="user_company.company_name" class="fs-14 text-gray mb-0 text-secondary text-capitalize">{{user_company.company_name || "-"}} <span class="text-secondary" >(Default)</span></h1>
                                                </div> -->
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="show-on-mob-screen text-right mx-3">
                                    <button class="btn btn-secondary btn-smm" @click="logout()">
                                        Logout
                                    </button>
                                </div>
                                <hr class="mt-2">
                                <div v-if="org_company_list_loading">
                                    <half-circle-spinner :animation-duration="1000" :size="30" color="#00448b" style="margin: 0 auto;" />
                                </div>
                                <template v-else>
                                    <div @scroll="scrollGetOrganizationAndComp" v-if="comp_data.length > 0" class="mt-2" :class="{'overflow-height':comp_data.length > 0}">
                                        <div v-for="(comp, comp_index) in comp_data" :key="comp_index">
                                            <!-- <hr class="mt-5"> -->
                                        <template v-if="loggedInUser.user_has == 'organization'">
                                            <div v-if="comp.company_list">
                                                <div class="d-flex align-items-center w-100 py-2">
                                                    <div class="w-100 px-2">
                                                        <div class="d-flex align-items-center main-dropdown subcompany-dropdown justify-content-between pointer pl-2 pr-4" :class="{'green-active-org':comp_index == 0,'br-t-r-5':comp.org_active}" @click="compActive(comp_index)">
                                                            <div class="d-flex align-items-center">
                                                                <avatar
                                                                    class="navbar-avatar navbar-avatar-org-name"
                                                                    :username="comp.organization_name.replace(/ .*/,'')"
                                                                    :src="''"
                                                                    :size="40"
                                                                    :rounded="false"
                                                                    :color="comp_index == 0 ? '#008b29' : '#ffffff'"
                                                                    :background-color="comp_index == 0 ? '#ffffff' : '#707070'">
                                                                </avatar>
                                                                <div class="mt-0 ml-3">
                                                                    <h1 class="fs-14 mb-0 text-capitalize fw-500" :class="{'text-white':comp_index == 0, 'text-gray':comp_index != 0}">{{comp.organization_name}}</h1>
                                                                </div>
                                                            </div>
                                                            <div v-if="comp.company_list.length > 0" class="mob-left-padding-drop">
                                                                <i style="font-size: 25px;" class="icon el-icon-arrow-up fw-700 org-icon-rotate-transition" :class="{'org-icon-rotate-down':!comp.org_active,'text-white':comp_index == 0, 'dc-text-black':comp_index != 0}"></i>
                                                                <!-- <i style="font-size: 25px;" v-else class="icon el-icon-arrow-down fw-700" :class="{'text-white':comp_index == 0, 'dc-text-black':comp_index != 0}"></i> -->
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div v-if="comp.org_active" class="px-2">
                                                    <div v-for="(company, company_index) in comp.company_list" :key="company_index" class="d-flex align-items-center w-100 company-list list-dropdown" v-show="!company.selected">
                                                        <div v-if="company.logo">
                                                            <img style="border-radius: 50%; border: 2px solid #ecf1f9;" :src="company.logo" width="30" height="30" />
                                                        </div>
                                                        <div v-else>
                                                            <avatar
                                                                class="navbar-avatar navbar-avatar-comp-name"
                                                                :username="company.company_name.replace(/ .*/,'')"
                                                                :src="''"
                                                                :size="30"
                                                                :rounded="false"
                                                                :color="company.selected ? '#ffffff' : '#ffffff'"
                                                                :background-color="company.selected ? '#008b29' : '#707070'">
                                                            </avatar>
                                                        </div>
                                                        <div class="w-100 pl-4">
                                                            <div class="d-flex align-items-center justify-content-between">
                                                                <div>
                                                                    <h1 class="fs-14 mb-0 text-capitalize fw-500" :class="{'text-success':company.selected, 'not-selected':!company.selected}">{{company.company_name}}</h1>
                                                                </div>
                                                                <div v-if="!company.selected" :class="{'cursor-not-allowed': !company.can_company_switch}">
                                                                    <h1 class="fs-14 text-secondary mb-0 pointer fw-500" :class="{'pointer-events-none': !company.can_company_switch}" @click="switchNewCompany(company.company_id, company.can_company_switch)">Switch</h1>
                                                                </div>
                                                                <div v-else class="pr-3">
                                                                    <i class="icon icon-check-circle text-success"></i>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </template>
                                        <template v-else>
                                            <div class="d-flex align-items-center w-100 company-list list-dropdown" v-show="!comp.selected">
                                                <div v-if="comp.logo">
                                                    <img style="border-radius: 50%; border: 2px solid #ecf1f9;" :src="comp.logo" width="30" height="30" />
                                                </div>
                                                <div v-else>
                                                    <avatar
                                                        class="navbar-avatar navbar-avatar-comp-name"
                                                        :username="comp.company_name.replace(/ .*/,'')"
                                                        :src="''"
                                                        :size="30"
                                                        :rounded="false"
                                                        :color="comp.selected ? '#ffffff' : '#ffffff'"
                                                        :background-color="comp.selected ? '#008b29' : '#707070'">
                                                    </avatar>
                                                </div>
                                                <div class="w-100 pl-4">
                                                    <div class="d-flex align-items-center justify-content-between">
                                                        <div>
                                                            <h1 class="fs-14 mb-0 text-capitalize fw-500" :class="{'text-success':comp.selected, 'not-selected':!comp.selected}">{{comp.company_name}}</h1>
                                                        </div>
                                                        <div v-if="!comp.selected" :class="{'cursor-not-allowed': !comp.can_company_switch}">
                                                            <h1 class="fs-14 text-secondary mb-0 pointer fw-500" :class="{'pointer-events-none': !comp.can_company_switch}" @click="switchNewCompany(comp.company_id, comp.can_company_switch)">Switch</h1>
                                                        </div>
                                                        <div v-else class="pr-3">
                                                            <i class="icon icon-check-circle text-success"></i>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </template>
                                    </div>
                                </div>
                                </template>
                            </div>
                        </div>
                    </div>
                </div>
                <div @click="showMenuPanel()" class="pointer" v-if="!show_menu_panel">
                    <img src="https://cdn.digicollect.com/cdn/scmnew/images/menu-collapse.svg" class="w-85">
                </div>
            </div>
        </div>
        <div v-if="minimizeMenu" class="user-menu-align">
            <div class="d-flex submenu-align pt-2 pb-3 justify-content-end mr-2">
                <div class="user-menu-button">
                    <el-dropdown class="pl-2 pr-0" trigger="click">
                        <span class="el-dropdown-link" @click="ReloadSearch">
                            <div class="d-flex align-items-center">
                                <div class="avatar-wrapper">
                                    <img src="https://cdn.digicollect.com/cdn/crm_menu/menus/search.svg" class="w-85">
                                </div>
                            </div>
                        </span>
                        <el-dropdown-menu slot="dropdown" class="searchBoxNavbar">
                            <div class="search-dropdown px-1 py-3 w-325px w-md-375px">
                                <div>
                                    <form class="w-100 position-relative" autocomplete="off">
                                        <span class="svg-icon svg-icon-2 svg-icon-lg-1 svg-icon-gray-500 position-absolute top-50 translate-middle-y ms-0">
                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <rect opacity="0.5" x="17.0365" y="15.1223" width="8.15546" height="2" rx="1" transform="rotate(45 17.0365 15.1223)" fill="currentColor"></rect>
                                                <path d="M11 19C6.55556 19 3 15.4444 3 11C3 6.55556 6.55556 3 11 3C15.4444 3 19 6.55556 19 11C19 15.4444 15.4444 19 11 19ZM11 5C7.53333 5 5 7.53333 5 11C5 14.4667 7.53333 17 11 17C14.4667 17 17 14.4667 17 11C17 7.53333 14.4667 5 11 5Z" fill="currentColor"></path>
                                            </svg>
                                        </span>
                                        <input type="text" class="search-input form-search-control form-control-flush ps-10" name="search" @input="SearchData" v-model="search_lcc" placeholder="Start your search…" />
                                        <span class="closebtn btn-flush btn-active-color-primary position-absolute top-50 end-0 translate-middle-y lh-0" v-if="search_lcc != ''" @click="search_lcc = ''">
                                            <span class="svg-icon svg-icon-2 svg-icon-lg-1 me-0">
                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)" fill="currentColor"></rect>
                                                    <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)" fill="currentColor"></rect>
                                                </svg>
                                            </span>
                                        </span>
                                    </form>
                                    <div class="separator border-gray-200 mb-1" v-if="searched_lists.length > 0"></div>

                                    <div class="mb-1 scroller" v-if="search_lcc.length" @scroll="infiniteSearchScroll">
                                        <!-- <div class="d-flex flex-stack fw-semibold mb-4">
                                            <span class="text-muted fs-13 me-2">Recently Searched:</span>
                                        </div> -->
                                        <div class="d-flex align-items-center justify-content-center w-100" v-if="loadSearch">
                                            <half-circle-spinner :animation-duration="1000" :size="50" color="#00448b"
                                                style="margin: 0 auto;" />
                                        </div>
                                        <div class="text-center" v-if="!loadSearch && searched_lists.length == 0">
                                            <div class="py-5">
                                                <span class="svg-icon svg-icon-4x opacity-50">
                                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path opacity="0.3" d="M14 2H6C4.89543 2 4 2.89543 4 4V20C4 21.1046 4.89543 22 6 22H18C19.1046 22 20 21.1046 20 20V8L14 2Z" fill="currentColor"></path>
                                                        <path d="M20 8L14 2V6C14 7.10457 14.8954 8 16 8H20Z" fill="currentColor"></path>
                                                        <rect x="13.6993" y="13.6656" width="4.42828" height="1.73089" rx="0.865447" transform="rotate(45 13.6993 13.6656)" fill="currentColor"></rect>
                                                        <path d="M15 12C15 14.2 13.2 16 11 16C8.8 16 7 14.2 7 12C7 9.8 8.8 8 11 8C13.2 8 15 9.8 15 12ZM11 9.6C9.68 9.6 8.6 10.68 8.6 12C8.6 13.32 9.68 14.4 11 14.4C12.32 14.4 13.4 13.32 13.4 12C13.4 10.68 12.32 9.6 11 9.6Z" fill="currentColor"></path>
                                                    </svg>
                                                </span>
                                            </div>
                                            <div class="pb-8 fw-semibold">
                                                <h3 class="text-gray-800 fs-14 mb-1 fw-600">
                                                    No Results Found
                                                </h3>
                                            </div>
                                        </div>
                                        <el-dropdown-item class="search-custom" v-else>
                                            <div class="scroll-y mh-200px mh-lg-325px" @click="RedirectActivityLog(data)" v-for="(data, index) in searched_lists" :key="index" >
                                                <div class="d-flex align-items-center pb-2 pt-2 section-hover borderBottom pointer">
                                                    <div class="imageSymbol imageSymbol-40px me-4">
                                                        <span class="imageSymbol-label">
                                                            <img class="imgAvatar" v-if="data.image" :src="data.image" :alt="data.user_name" />
                                                            <img class="imgAvatar" v-else src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/No%20Picture.svg" :alt="data.user_name" />
                                                        </span>
                                                    </div>
                                                    <div class="d-flex flex-column">
                                                        <a href="javascript:;" class="fs-14 text-gray-800 text-hover-primary fw-semibold text-decoration-none text-truncate mw-300">{{data.user_name}} {{data.company ? `(${data.company})` : ''}}</a>
                                                        <span class="fs-13 text-muted fw-semibold">{{data.type}}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </el-dropdown-item>
                                    </div>
                                </div>
                            </div>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>

                <!-- Notifications Popup start -->

                <div class="pr-0">
                    <el-dropdown class="pl-2 pr-2" trigger="click">
                        <span class="el-dropdown-link">
                            <div class="d-flex align-items-center">
                                <div class="avatar-wrapper position-relative" @click="getNotificationsClick">
                                    <div class="text-center text-white notification-count" v-if="total_notifications_count > 0">{{total_notifications_count | messageCount}}</div>
                                    <img src="https://cdn.digicollect.com/cdn/scmnew/images/images-new-theme/notification.svg" class="w-85">
                                </div>
                            </div>
                        </span>
                        <el-dropdown-menu slot="dropdown" class="searchBoxNavbar">
                            <div class="d-flex justify-content-between notification-dropdown px-1 py-3 w-325px w-md-375px">
                                <div class="lh-24px fs-15 ml-2 fw-500">Notifications ({{total_notifications_count}})</div>
                                <!-- <i class="icon icon-close-circle"></i> -->
                            </div>
                            <div v-if="notifications_list_loading && notifications_list.length <= 0" class="mb-3">
                                <half-circle-spinner :animation-duration="1000" :size="20" color="#00448b" style="margin: 0 auto;" />
                            </div>
                            <div v-if="!notifications_list_loading && notifications_list.length <= 0" class="d-flex justify-content-center align-items-center">
                                <h6>No Notifications Found</h6>
                            </div>
                            <div v-else class="scroller" @scroll="infiniteScroll">
                                <el-dropdown-item class="search-custom-note m-1" @click.native="viewReminder(note)" :class="note.is_read ? 'selected' : ''" v-for="(note, index) in notifications_list" :key="index">
                                    <div class="d-flex justify-content-between align-items-center" style="border-bottom: solid 1px #e4e4e4;">
                                        <div>
                                            <div class="fw-normal fs-14 fw-500 messageText" :title="note.message">{{note.message}}</div>
                                            <div class="fw-normal fs-12">{{note.create_datetime}}</div>
                                        </div>
                                        <div>
                                            <div style="background-color: rgb(0, 68, 139);height: 35px;width: 35px;border-radius: 100%;" class="d-flex">
                                                <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/newcrm/clock_white.svg" v-if="note.img_type == 'follow_up'" class="margin-auto-img" alt="Follow Up" width="15">
                                                <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/newcrm/white-calendar-new.svg" v-if="note.img_type == 'event'" class="margin-auto-img" alt="Event" width="15">
                                                <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/newcrm/megaphone.svg" v-if="note.img_type == 'task'" class="margin-auto-img" alt="Task" width="15">
                                                <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/newcrm/bell_icon.svg" v-if="note.img_type == 'reminder'" class="margin-auto-img" alt="Remainder" width="15">
                                            </div>
                                        </div>
                                    </div>
                                </el-dropdown-item>
                            </div>

                            <div v-if="(ajax_loader && notifications_list.length > 0)" class="d-flex justify-content-center align-items-center notify-loader">
                                <half-circle-spinner :animation-duration="1000" :size="35" color="#00448b" style="margin: 0 auto;" />
                            </div>
                            <el-dropdown-item class="px-0">
                                <div class="d-flex justify-content-between px-3 py-1 w-325px w-md-375px" style="border-top:1px solid #afafaf">
                                    <div class="lh-30px fs-12 fw-600 text-secondary pointer" @click="gotoNotifications">View All Notifications</div>
                                    <div class="lh-30px fs-12 fw-600 pointer text-secondary" v-if="notifications_list.length" @click="MarkAllAsRead">Mark All Read</div>
                                    <div class="lh-30px fs-12 fw-600 text-grey" v-else>Mark All Read</div>
                                </div>
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
                <div v-if="show_menu_panel" class="dropdown px-sm-0 mr-1">
                    <div class="dropdown-toggle pointer dropdownhideafter row align-items-center no-gutters text-white box-shadow" role="button" id="dropdownShortcutMenu" @click="showProductList" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <el-tooltip class="item" effect="dark" content="Products" placement="top">
                            <img src="https://cdn.digicollect.com/cdn/scmnew/images/menus/images/products.svg" class="w-85">
                        </el-tooltip>
                    </div>
                    <product-dropdown></product-dropdown>
                </div>
                <div v-if="show_menu_panel" class="dropdown timezone-button" style="margin-top: 3px !important;">
                    <div class="dropdown-toggle row align-items-center justify-content-center no-gutters px-0 px-sm-4 btn btn-icon text-white products-button" role="button" id="dropdownLanguageMenu" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <div class="row no-gutters align-items-center justify-content-center font-weight-bold">
                            <span class="text-white" v-if = "guess" >
                                {{timeDefault}}
                            </span>
                            <span class="text-white" v-else-if = "newyork">
                                {{timeNewYork}}
                            </span>
                            <span class="text-white" v-else-if = "london">
                                {{timeLondon}}
                            </span>
                            <span class="text-white" v-else-if = "kolkata">
                                {{timeKolkata}}
                            </span>
                            <span class="text-white" v-else-if = "singapore">
                                {{timeSingapore}} SGT
                            </span>
                            <span class="text-white" v-else-if = "yangon">
                                {{timeYangon}} MMT
                            </span>
                            <span class="text-white" v-else-if = "bangkok">
                                {{timeThailand}} ICT
                            </span>
                        </div>
                    </div>
                    <div class="dropdown-menu dropdown-time timezone" aria-labelledby="dropdownLanguageMenu">
                        <a class="dropdown-item" href="#">
                            <div class="row no-gutters align-items-center flex-nowrap">
                                <span class="px-3" v-on:click = ' guess = false, newyork = true, london=false, kolkata=false, singapore=false, bangkok=false, yangon=false'>{{timeNewYork}}</span>
                            </div>
                        </a>
                        <a class="dropdown-item" href="#">
                            <div class="row no-gutters align-items-center flex-nowrap">
                                <span class="px-3"  v-on:click = ' guess = false, newyork = false, london=true, kolkata=false, singapore=false, bangkok=false, yangon=false'>{{timeLondon}}</span>
                            </div>
                        </a>
                        <a class="dropdown-item" href="#">
                            <div class="row no-gutters align-items-center flex-nowrap">
                                <span class="px-3" v-on:click = ' guess = false, newyork = false, london=false, kolkata=true, singapore=false, bangkok=false, yangon=false'>{{timeKolkata}}</span>
                            </div>
                        </a>
                        <a class="dropdown-item" href="#">
                            <div class="row no-gutters align-items-center flex-nowrap">
                                <span class="px-3" v-on:click = ' guess = false, newyork = false, london=false, kolkata=false, singapore=true, bangkok=false, yangon=false'>{{timeSingapore}} SGT</span>
                            </div>
                        </a>
                        <a class="dropdown-item" href="#">
                            <div class="row no-gutters align-items-center flex-nowrap">
                                <span class="px-3"  v-on:click = ' guess = false, newyork = false, london=false, kolkata=false, singapore=false, bangkok=false, yangon=true'>{{timeYangon}} MMT</span>
                            </div>
                        </a>
                        <a class="dropdown-item" href="#">
                            <div class="row no-gutters align-items-center flex-nowrap">
                                <span class="px-3"  v-on:click = ' guess = false, newyork = false, london=false, kolkata=false, singapore=false, yangon=false, bangkok=true'>{{timeThailand}} ICT</span>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <div class="mt-3 justify-content-center animated" style="display: flex" :class="{'in-down':show_menu_panel == false || show_menu_panel,'d-none':!show_menu_panel,'fadeOut': show_menu_panel == false}" v-if="show_menu_panel">
            <menubar :show_menu_panel="show_menu_panel" @toggleMenuPanel="show_menu_panel = false"></menubar>
        </div>
        <div class="mt-3 justify-content-center animated" style="display: flex" :class="{'in-down':switch_success == false || switch_success,'d-none':!switch_success,'fadeOut': switch_success == false}" v-if="switch_success">
            <switch-company-success @hideSuccess="hideSuccess" modal_name="switch-success" :company_success_msg="company_success_msg"></switch-company-success>
        </div>
        <sweet-modal ref="success_modal" icon="success">{{success_msg}}</sweet-modal>
        <sweet-modal ref="warning_modal" icon="warning">{{warning_msg}}</sweet-modal>
        <create-reminder :from_notification="true" :reminderType="reminderType" v-if="createReminderShow" :mode_id="mode_id" :view_mode="view_mode" modal_name="createReminder" @hideCreateReminder="hideCreateReminder"></create-reminder>
    </div>
</template>
<script>
import { EventBus } from "./eventBus/nav-bar-event.js";
import globals from "./globals"
import { mapGetters } from "vuex";
import Avatar from 'vue-avatar';
import moment from "moment-timezone";
import axios from "axios";
import navbarMixin from "./mixins/navbarMixin.js";
import notificationMixin from "./mixins/notification.js";
import { User } from "./mixins/user.js";
import { EmployeeManage } from "./mixins/employees.js";
const Menubar = () => import('./Menubar');
const SwitchCompanySuccess = () => import('./SwitchCompanySuccess');
const Toolbar = () => import('./Toolbar');
const ProductDropdown = () => import('./ProductDropdown');
import { HalfCircleSpinner } from 'epic-spinners'
import createReminder from './Reminders/CreateReminder.vue'
import {
    SweetModal
} from 'sweet-modal-vue';
import { company } from './mixins/companySetup.js';
export default {
	mixins: [navbarMixin, User, EmployeeManage, notificationMixin],
    data() {
        return {
            isp_stable: false,
            show_menu_panel: true,
            toggleSideBar: false,
            success_msg: '',
            warning_msg: '',
			togglemenu: true,
			timeDefault: moment().tz(moment.tz.guess()).format("LTS z"),
			timeNewYork: moment().tz("America/New_York").format("LTS z"),
			timeLondon: moment().tz("Europe/London").format("LTS z"),
			timeKolkata: moment().tz("Asia/Kolkata").format("LTS z"),
			timeSingapore: moment().tz("Asia/Singapore").format("LTS"),
			timeYangon: moment().tz("Asia/Yangon").format("LTS"),
            timeThailand: moment().tz("Asia/Bangkok").format("HH:mm:ss"),
			timedefault: "",
			guess: true,
			newyork: false,
			london: false,
			kolkata: false,
			singapore: false,
			yangon: false,
			selectedTimeZone: "",
			universalSearch: false,
			seeRequests: false,
			account_details: {},
			search_key: "",
			searched_data: [],
			skip: 0,
			limit: 5,
			convert_data: "",
			employeeDataCount: [],
			contactRequestTab: false,
			employeeRequestTab: false,
			ajaxCallinprogress: false,
			productsList: [],
            comp_data: [],
            comp_limit: 10,
            given_comp_index: 0,
            new_token: "",
            comp_active: false,
            switch_success: false,
            user_company:[],
            company_success_msg:'',
            searched_lists:[],
            search_lcc: '',
            loadSearch: false,
            search_count: 0,
            temp_search: [],

            notifications_list: [],
            ajax_loader: false,
            notifications_count: 0,
            total_notifications_count: 0,
            total_notification: 0,
            reminderType: 'My Reminders',
            createReminderShow: false,
            mode_id: '',
            view_mode: '',
            show_hide_comp_switch_dropdown: false,
            org_comp_count: 0,
            scroll_flag: false,
            org_company_list_flag: false,
            org_company_list_loading: false,
            notifications_list_loading: false,
            notifications_list_loading_flag: false,
			minimizeMenu: false,
        };
    },
    components: {
        HalfCircleSpinner,
		ProductDropdown,
        Menubar,
        Toolbar,
        SwitchCompanySuccess,
        SweetModal,
        createReminder,
        Avatar
    },
    // Notification Badge Count limited to 99+ count
    filters: {
        messageCount: function (value) {
            if (!value) {
                return 0;
            }
            return value > 99 ? '99+' : value;
        }
    },
    methods: {
        menuBars(i){
            if(i == 'submenu'){
                this.minimizeMenu = !this.minimizeMenu
            }
        },
        showProductList() {
            EventBus.$emit('product_list_api_call_for_dropdown')
        },
        checkISP(){
            setInterval(() => {
                if(navigator.onLine){
                    this.isp_stable = true
                }
                else{
                    this.isp_stable = false
                }
            }, 1000);
        },
        gotoNotifications(){
            if(this.$route.path != '/notifications'){
                this.$router.push({
                    path: '/notifications'
                })
            }
        },
        async viewReminder(note){
            if(note.goto == 'reminder'){
                if(note.is_read == false){
                    let res = await this.MarkAsRead({
                        id: note._id
                    })
                }
                this.$router.push({
                    path: '/notifications',
                    query: {
                        note_details: note
                    }
                })
                EventBus.$emit('ReloadNotification', note)
                this.getNotifications()
            }
        },
        async MarkAllAsRead(){
            let res = await this.MarkAsRead({
                is_all_read:true
            })
            EventBus.$emit('RecallNotificationsPage')
            this.getNotifications();
        },
        hideCreateReminder(recall_api){
            this.createReminderShow = false;
        },
        getNotificationsClick() {
            if(this.notifications_list_loading_flag == false) {
                this.getNotifications();
            }
            
        },
        async getNotifications(){
            this.notifications_count = 0
            this.notifications_list_loading = true
            let params = {
                "skip":this.notifications_count,
                "limit":10,
            }
            let response = await this.NotificationsList(params)
            this.notifications_list = response.response
            this.notifications_count = this.notifications_list.length
            this.total_notification = response.total_count
            this.total_notifications_count = response.count
            this.notifications_list.forEach((x) => {
                let d = new Date(x.created_date + ' ' + x.created_time);
                let ye = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(d);
                let mo = new Intl.DateTimeFormat('en', { month: 'short' }).format(d);
                let da = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(d);
                x['create_datetime'] = da + ' ' + mo + ' ' + ye + ' at ' + x.created_time
            })
            this.notifications_list_loading = false
            this.notifications_list_loading_flag = true
        },

        async infiniteScroll(e) {
            const {
            target
            } = e;
            if (Math.ceil(target.scrollTop) >= target.scrollHeight - target.offsetHeight) {
                try {
                    if(this.total_notification != this.notifications_count){
                        this.ajax_loader = true
                        let params = {
                            "skip":this.notifications_count,
                            "limit":10,
                        }
                        let response = await this.NotificationsList(params)
                        this.total_notifications_count = response.count
                        if (response.skip == this.notifications_count) {
                            let tempFiles = response.response
                            tempFiles.forEach((x) => {
                                let d = new Date(x.created_date + ' ' + x.created_time);
                                let ye = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(d);
                                let mo = new Intl.DateTimeFormat('en', { month: 'short' }).format(d);
                                let da = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(d);
                                x['create_datetime'] = da + ' ' + mo + ' ' + ye + ' at ' + x.created_time
                            })
                            tempFiles.forEach(el => {
                                this.notifications_list.push(el)
                            })
                            this.notifications_list = this.notifications_list.filter((thing, index) => {
                                const payload = JSON.stringify(thing);
                                return index === this.notifications_list.findIndex(obj => {
                                    return JSON.stringify(obj) === payload;
                                });
                            });
                            this.notifications_count += response.response.length
                            this.ajax_loader = false
                        }
                    }
                } catch (reason) {
                }
            }
        },
        ReloadSearch(){
            this.search_lcc = ''
            this.searched_lists = []
        },
        async SearchData(){
            this.searched_lists = []
            this.search_count = 0
            this.loadSearch = true
            let params = {
                "search_key": this.search_lcc,
                "skip": this.search_count,
                "limit": 10
            }
            let response = await this.GetWholeSearchData(params);
            this.searched_lists = response.response
            this.search_count = this.searched_lists.length
            this.loadSearch = false
        },
        async infiniteSearchScroll(e){
            const {
                target
            } = e;
            if (Math.ceil(target.scrollTop) >= target.scrollHeight - target.offsetHeight) {
                try {
                    let params = {
                        "search_key": this.search_lcc,
                        "skip": this.search_count,
                        "limit": 10
                    }
                    let response = await this.GetWholeSearchData(params);
                    this.temp_search = response.response
                    if (response.skip == this.search_count) {
                        let tempFiles = this.temp_search
                        tempFiles.forEach(x => {
                            this.searched_lists.push(x)
                        })
                        this.search_count += this.temp_search.length
                    }
                } catch(error){
                }
            }
        },
        RedirectActivityLog(data){
            if(data.type == "Customer"){
                this.$router.push({
                    path: `/activitylogs/activityLog/${data.id}`,
                    query: {
                        name: data.user_name,
                        type: data.type,
                        profile_pic: data.image
                    },
                    mode: 'abstract'
                })
                EventBus.$emit('RecallActivityLog')
            } else if(data.type == 'Contact'){
                this.$router.push({
                    path: `/activitylogs/activityLog/${data.id}`,
                    query: {
                        name: data.user_name,
                        type: data.type,
                        profile_pic: data.image
                    },
                    mode: 'abstract'
                })
                EventBus.$emit('RecallActivityLog')
            } else if(data.type == 'Lead'){
                this.$router.push({
                    path: `/activitylogs/activityLog/${data.id}`,
                    query: {
                        name: data.user_name,
                        type: data.type,
                        profile_pic: data.image,
                        level: data.level
                    },
                    mode: 'abstract'
                })
                // localStorage.setItem("leads_type",this.leadsToShow == 'Manual' ? 'Manual' : this.leadsToShow == 'Archive' ? 'Archive' : 'Converted')
                EventBus.$emit('RecallActivityLog')
            }
        },
        showMenuPanel(){
            setTimeout(() => {
                this.show_menu_panel = true
            }, 200);
        },
        setCookie(days) {
            var expires = "";
            if (days) {
                var date = new Date();
                date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
                expires = "; expires=" + date.toUTCString();
            }
            document.cookie = "Token" + "=" + (this.new_token || "") + expires + ";domain=.digicollect.com; path=/";
        },
        hideSuccess() {
            this.switch_success = false;
            this.setCookie(7);
            setTimeout(() => {
                axios.defaults.headers.common.Authorization = this.$cookie.get("Token");
                window.location.reload();
            }, 500);
        },
        showHideCompSwitchDropdown() {
            this.show_hide_comp_switch_dropdown = !this.show_hide_comp_switch_dropdown
            if(this.org_company_list_flag == false) {
                this.getOrganizationAndComp();
            }
        },
        onBlurHideCompSwitch(e) {
            if (this.$el.contains(e.target)) {
                this.show_hide_comp_switch_dropdown = false
            }
        },
        logout() {
            EventBus.$emit('UnSubscribe')
            axios.get(globals.AUTH_SERVICE + '/auth/logout').then((resp)=>{
				if(resp.data.status_id == 1) {
					this.$cookie.delete("Token");
					this.$cookie.delete('Token', {
						domain: 'digicollect.com'
					});
					/*this.$cookie.delete('Token', {
						domain: 'crm.digicollect.com'
					});*/
					window.location.href = globals.CRM_URL;
				}
			}).catch((err)=>{
				this.$cookie.delete("Token");
				this.$cookie.delete('Token', {
					domain: 'digicollect.com'
				});
				/*this.$cookie.delete('Token', {
					domain: 'crm.digicollect.com'
				});*/
				window.location.href = globals.CRM_URL;
			})
		},
		// Redirection to Request Page
		goToManager() {
			this.$router.push({
				name: 'ManageRequests'
			})
			window.location.reload()
		},
		// Redirection to Notification Page
		goToNotification() {
			this.$router.push({
				name: 'Notification'
			});
			window.location.reload()
		},
		// Redirection to New User Page
		goToAddNewUser() {
			this.$router.push({
				name: 'AddNewUser'
			})
		},

		goToProfile(id) {
			this.$router.push("/userprofile/" + id);
		},
		// Redirection to Company Profile Page
		gotoCompany(data) {
			this.convert_data = data.$oid
			var convert_data = data.$oid
			this.$router.push("/companyprofile/" + data);
		},
		// Not Used
		addEmployee() {
			//this.$modal.show("add-employee-modal")
			this.$router.push('/addemployee');
		},
		// Search User, Companies and Employees
		searchUser() {
			this.$http
				.post("/universal_search", {
					search_key: this.search_key,
					skip: 0,
					limit: 5
				})
				.then(response => {
					if (response.data.status_id == 1) {
						this.searched_data = response.data.response
						// this.userData = response.data.response;
					}
				})
				.catch(error => {});
		},
		clearSearchkey() {
			this.search_key = ""
		},
		toggleBtn1() {
			EventBus.$emit("navBarClick", true);
		},
		select() {
			EventBus.$emit("topBar", true);
		},
		setTimeZone(timezone) {
			this.$store.dispatch("setTimezone", timezone);
		},
		searchCRM: function () {
			this.universalSearch = !this.universalSearch;
		},
		searchComponent: function () {
			this.$router.push({
				path: "/universalsearch/"
			});
			this.universalSearch = false;
		},
		// Switch Account Between Profile and Company and Set Token
        /**@params = account_id, @params =index */
		switchAccount(account_id, index) {
			if (account_id != null) {
				this.$http.post("/change_account", {
					account_id: account_id
				}).then(res => {
					if (res.data.status_id == 1) {
						this.$cookie.set("Token", res.data.Authorization, {
							expires: 7,
							domain: "digicollect.com"
						})
						axios.defaults.headers.common.Authorization = this.$cookie.get("Token");
						window.location.reload()
					}
				})
			} else {
				this.$http.get("/change_account").then(res => {
					if (res.data.status_id == 1) {
						this.$cookie.set("Token", res.data.Authorization, {
							expires: 7,
							domain: "digicollect.com"
						})
						axios.defaults.headers.common.Authorization = this.$cookie.get("Token");
						window.location.reload()
					}
				})
			}
		},
		// Check Request For Employee or Personal
		// getRequestType() {
		// 	if (this.account) {
		// 		this.requestType = "business"
		// 	} else {
		// 		this.requestType = "personal"
		// 	}
		// },
		// Get ALL Request API
		getUserEmployeeRequest() {
			this.ajaxCallinprogress = true;
			this.$http.post("/employees/user_pending_requests", {
				skip: this.skip,
				limit: this.limit,
				search_key: ""
			})
			.then(res => {
				if (res.data.status_id == 1) {
					this.employeeDataCount = res.data.response;
					this.ajaxCallinprogress = false;
				}
			});
		},
		// Change Tab View Contact and Employee Request
		// changeModelView(viewName) {
		// 	switch (viewName) {
		// 		case 'contactTab':
		// 			this.contactRequestTab = true;
		// 			this.employeeRequestTab = false;
		// 			this.getConnectionRequestsAPI();
		// 			break;
		// 		case 'employeeTab':
		// 			this.contactRequestTab = false;
		// 			this.employeeRequestTab = true;
		// 			this.getUserEmployeeRequest();
		// 			break;
		// 	}
		// },
		// Check Connection Status For Personal and Employee
		// getConnectionRequestsAPI() {
		// 	this.getConnectionRequests();
		// },
		// Button Actions for Accept and Reject
		// async changeStatus(status, id, sent_by) {
		// 	let params = {
		// 		notification_id: id,
		// 		sent_by: sent_by,
		// 	};
		// 	let res = await this.$http.post(status == 'connected' ? "/connections/accept" : "/connections/reject",
		// 		params);
		// 	if (res.data.status_id == 1) {
		// 		if (status == "disconnected") {
		// 			this.$awn.success("Request Disconnected Successfully")
		// 		}
		// 		if (status == "delete") {
		// 			this.$awn.success("Request Deleted Successfully")
		// 		}
		// 		if (status == "connected") {
		// 			this.$awn.success("Request Accepted Successfully")
		// 		}
		// 		if (status == "ignore") {
		// 			this.$awn.success("Request Rejected Successfully")
		// 		}
		// 		this.getConnectionRequestsAPI();
		// 	}
		// },
		// async getProducts() {
		// 	let res = await this.$http.get("/company/get_products_purchased_not_purchased");
		// 	if (res.data.status_id == 1) {
		// 		res.data.response.not_purchased_products.forEach(x => {
		// 			this.productsList.push(x);
		// 		});
		// 		res.data.response.purchased_products.forEach(x => {
		// 			this.productsList.push(x);
		// 		});
		// 	}
		// }
        goToSettings() {
            if(location.origin.startsWith('https://testcrm.digicollect.com') || location.origin.startsWith('http://localhost')){
                window.open('https://testadmin.digicollect.com/','_blank');
            }else if(location.origin.startsWith('https://crm.digicollect.com')){
                window.open('https://admin.digicollect.com/','_blank');
            }
            // if(location.origin.startsWith('http://localhost') || 'https://testcrm.digicollect.com/'){
            //     window.open('https://testadmin.digicollect.com/','_blank');
            // }else if(location.origin == 'https://crm.digicollect.com/'){
            //     window.open('https://admin.digicollect.com/','_blank');
            // }
            this.show_hide_comp_switch_dropdown = false
            // this.$router.push('/settingComponents');
        },
        compActive(index) {
            // this.comp_data.forEach((org,org_index) => {
            //     org.org_active = false
            // })
            this.comp_data[index].org_active = !this.comp_data[index].org_active
            this.$forceUpdate();
        },
        async getOrganizationAndComp() {
            try {
                this.org_company_list_loading = true;
                let param = {
                    skip: this.skip,
                    limit: this.comp_limit,
                    search_key: this.search_key,
                    is_company_switcher: true,
                    product: "CRM"
                };
                let response = await this.getHierarchyListView(param);
                if(response.status_id == 1) {
                    this.comp_data = response.response;
                    if(this.loggedInUser.user_has == 'organization') {
                        this.comp_data.forEach((element, index) => {
                            element['org_active'] = false
                            element.company_list.forEach((element1, index1) => {
                                if(element1.selected) {
                                    this.outer_el = index;
                                    this.inner_el = index1;
                                }
                                return;
                            });
                            return;
                        });
                        var element = this.comp_data[this.outer_el];
                        var element1 = element.company_list[this.inner_el];
                        element.company_list.splice(this.inner_el, 1);
                        element.company_list.splice(0, 0, element1);
                        this.comp_data.splice(this.outer_el, 1);
                        this.comp_data.splice(0, 0, element);
                    } else if(this.loggedInUser.user_has == 'company') {
                        this.comp_data.forEach((element, index) => {
                            if(element.selected) {
                                this.outer_el = index;
                            }
                            return;
                        });
                        var element = this.comp_data[this.outer_el];
                        this.comp_data.splice(this.outer_el, 1);
                        this.comp_data.splice(0, 0, element);
                    }
                    this.user_company = response.user_company;
                    this.org_comp_count = response.response.length;
                    this.org_company_list_flag = true;
                    this.org_company_list_loading = false;
                }
            }
            catch(err) {
                // console.log(err);
            }
        },
        async scrollGetOrganizationAndComp(e) {
			if(this.scroll_flag == false) {
                const {target} = e;
                if (Math.ceil(target.scrollTop) >= target.scrollHeight - target.offsetHeight) {
                    //this code will run when the user scrolls to the bottom of this div so
                    //you could do an api call here to implement lazy loading
                    // set scroll_flag true immediately so rapid/duplicate scroll events don't
                    // fire the same request again before this one resolves (was causing duplicate entries)
                    this.scroll_flag = true;
                    try {
                        let param = {
                            skip: this.org_comp_count,
                            limit: this.comp_limit,
                            search_key: this.search_key,
                            is_company_switcher: true,
                            product: "CRM"
                        };
                        let response = await this.getHierarchyListView(param);
                        if(response.status_id == 1) {
                            if (response.skip == this.org_comp_count) {
                                let tempFiles = response.response
								// this.scroll_flag = response.response.length ? false : true
                                // the API re-includes the currently selected org/company (pinned to the top)
                                // on every page, so pushing tempFiles as-is re-adds it on each scroll load.
                                // Filter out anything whose company_id we've already loaded before pushing.
                                if(this.loggedInUser.user_has == 'organization') {
                                    let existingCompanyIds = new Set(
                                        this.comp_data.flatMap(o => (o.company_list || []).map(c => c.company_id))
                                    );
                                    tempFiles = tempFiles.filter(el =>
                                        !(el.company_list || []).some(c => existingCompanyIds.has(c.company_id))
                                    );
                                } else if(this.loggedInUser.user_has == 'company') {
                                    let existingCompanyIds = new Set(this.comp_data.map(c => c.company_id));
                                    tempFiles = tempFiles.filter(el => !existingCompanyIds.has(el.company_id));
                                }
                                tempFiles.forEach(el => {
                                        this.comp_data.push(el)
                                })
                                if(this.loggedInUser.user_has == 'organization') {
                                    this.comp_data.forEach((element, index) => {
                                        if(element.hasOwnProperty('org_active')) {
                                            if(element.org_active == false) {
                                                element['org_active'] = false
                                            } else {
                                                element['org_active'] = true
                                            }
                                        } else {
                                            element['org_active'] = false
                                        }
                                        element.company_list.forEach((element1, index1) => {
                                            if(element1.selected) {
                                                this.outer_el = index;
                                                this.inner_el = index1;
                                            }
                                            return;
                                        });
                                        return;
                                    });
                                    var element = this.comp_data[this.outer_el];
                                    var element1 = element.company_list[this.inner_el];
                                    element.company_list.splice(this.inner_el, 1);
                                    element.company_list.splice(0, 0, element1);
                                    this.comp_data.splice(this.outer_el, 1);
                                    this.comp_data.splice(0, 0, element);
                                } else if(this.loggedInUser.user_has == 'company') {
                                    this.comp_data.forEach((element, index) => {
                                        if(element.selected) {
                                            this.outer_el = index;
                                        }
                                        return;
                                    });
                                    var element = this.comp_data[this.outer_el];
                                    this.comp_data.splice(this.outer_el, 1);
                                    this.comp_data.splice(0, 0, element);
                                }
                                this.org_comp_count += response.response.length;
                            }
                            // unlock only after skip/org_comp_count has been updated above
                            this.scroll_flag = response.response.length ? false : true
                        } else {
                            this.scroll_flag = false;
                        }
                    } catch (reason) {
                        this.scroll_flag = false;
                    }
                }
            }
        },
        //Api call to swtich company
        /**@params = comp_id, @params = is_swtich */
        async switchNewCompany(comp_id, is_switch) {
            if(is_switch) {
                try {
                    let params = {
                        company_id: comp_id
                    }
                    let response = await this.switchCompany(params);
                    if(response.token) {
                        this.new_token = response.token;
                        this.$cookie.delete("Token");
                        this.$cookie.delete('Token', {
                            domain: 'digicollect.com'
                        });
                        this.show_hide_comp_switch_dropdown = false
                        this.switch_success = true;
                        setTimeout(() => {
                            this.$modal.show('switch-success');
                        }, 500);
                    }
                    this.company_success_msg = response.message

                }
                catch(err) {
                }
            }
        }
    },
    computed: {
        loggedInUser() {
			return this.$store.state.loggedInUser;
		},
		isBusinessAccount() {
			return this.$store.state.isBusinessAccount;
		},
		account() {
			return this.$store.state.account;
		},
		selectedCompany() {
			return this.$store.state.selectedCompany;
        },
        userPermissions(){
            return this.$store.getters.userPermissions;
        }
    },
    async mounted() {
        this.checkISP()
		setInterval(() => {
            (this.timeDefault = moment().tz(moment.tz.guess()).format("HH:mm:ss z")),
            (this.timeNewYork = moment().tz("America/New_York").format("HH:mm:ss z")),
            (this.timeLondon = moment().tz("Europe/London").format("HH:mm:ss z")),
            (this.timeKolkata = moment().tz("Asia/Kolkata").format("HH:mm:ss z")),
            (this.timeSingapore = moment().tz("Asia/Singapore").format("HH:mm:ss")),
            (this.timeYangon = moment().tz("Asia/Yangon").format("HH:mm:ss")),
            (this.timeThailand = moment().tz("Asia/Bangkok").format("HH:mm:ss"));
        }, 1000)
		EventBus.$on("navBarClick", toggle => {
			this.isHidden = !this.isHidden;
			this.togglemenu = !this.togglemenu;
		});
		// EventBus.$on("updateNotification", () => {
		// 	this.getNotificationRequests();
		// });
        EventBus.$on('RecallNotifications', () => {
            this.getNotifications()
        })
		// this.getOrganizationAndComp();
		// this.getRequestType();
		// this.getConnectionRequestsAPI();
		// this.changeModelView('contactTab');
		// this.getNotificationRequests();
        // this.getNotifications();
	},

    // mounted() {
        // var dropdown = document.getElementsByClassName("dropdown-width");
        // var i;

        // for (i = 0; i < dropdown.length; i++) {
        //     dropdown[i].addEventListener("click", function() {
        //         this.classList.toggle("active");
        //         var dropdownContent = this.nextElementSibling;
        //         if (dropdownContent.style.display === "block") {
        //             dropdownContent.style.display = "none";
        //             } else {
        //             dropdownContent.style.display = "block";
        //             }
        //         });
        //     }
    //     var nav = document.querySelector('');
    //     nav.addEventListener('toggle', function(event) {
    //         if (!event.target.open) return;
    //         var dropdowns = nav.querySelectorAll('.open-dropdown[open]');
    //         Array.prototype.forEach.call(dropdowns, function (dropdown) {
    //             if (dropdown === event.target) return;
    //             dropdown.removeAttribute('open');
    //         });

    //     }, true);
    // }
};
</script>
<style scoped>
.background{
    background-color: #00448b;
    width: 100%;
    padding: 19px 15px 0px 15px;
    user-select: none;
}
.header{
    display: flex;
    color: #fff;
    align-items: center;
    justify-content: space-between;
}
.header-company{
    font-weight: 600;
    font-size: 20px;
    letter-spacing: 0.04em;
}
.product{
    display: flex;
    align-items: center;
    margin: 0 auto;
    justify-content: center;
    position: absolute;
    left: 46%;
}
.l-0{
    left: 16px !important
}
.product-logo i{
    color: #fff;
    font-weight: bold;
    text-decoration: none;
    font-size: 17px;
    position: relative;
    top: 2px;
}
.product-name{
    margin-left: 10px;
    color: #fff;
    font-weight: bold;
    font-size: 17px;
    text-decoration: none;
}
.searchContent {
    background-color: #4b9be6;
    color: white;
    border-radius: 50%;
    padding-left: 7px !important;
    padding-right: 5px !important;
    padding-top: 5px !important;
    padding-bottom: 5px !important;
}
.searchContentProduct{
    background-color: #1c61c2;
    color: white;
    border-radius: 50%;
    padding-left: 5px !important;
    width: 3.4rem;
    height: 3.4rem;
    line-height: 3rem;
}
.searchProductContent {
    height: 23px;
    width: 14px;
}
.dropdown-toggle.text-white::after {
    color: #fff !important;
}
.dropdown-apps {
    width: 320px;
    min-height: 100px;
    max-height: 400px;
    overflow-y: auto;
    top: 11px !important;
}
.dropdown-menu {
    -webkit-border-radius: 8px!important;
    border-radius: 8px!important;
    border: 1px solid #cdd2da!important;
    -webkit-box-shadow: 3px 2px 20px rgba(0,0,0,.2)!important;
    box-shadow: 3px 2px 20px rgba(0,0,0,.2)!important;
}
.dropdown-time {
    top: 11px !important;
}
.uk-margin-bottom {
    margin-bottom: 16px !important;
}
.uk-grid:after,
.uk-grid:before {
    content: "";
    display: block;
    overflow: hidden;
}
[class*="uk-grid-width"] > * {
    box-sizing: border-box;
    width: 100%;
}
.uk-grid-width-medium-1-3 > * {
     width: 33.333%;
}
.uk-margin-top {
    margin-top: 15px !important;
}
@media (min-width: 1220px) {
    .uk-grid > * {
        padding-left: 0px;
    }
}
.uk-grid > * {
    -ms-flex: none;
    -webkit-flex: none;
    flex: none;
    margin: 0;
    float: left;
    text-align: center;
    text-decoration: none;
}
.uk-grid > *:hover {
    text-decoration: none;
}
i.material-icons.md-36 {
    font-size: 36px !important;
    vertical-align: -36px;
    line-height: 36px;
    height: 36px;
    width: 36px;
    padding-bottom: 15px;
    color: #00448b !important;
}
.uk-grid > * > :last-child {
    margin-bottom: 0;
}
.uk-text-muted {
    color: #212121 !important;
}
.uk-display-block {
    display: block !important;
}
.logoblock .uk-display-block {
    margin-top: 8px;
}
.products-button{
    height: 3.1rem !important;
    line-height: 3.1rem !important;
    border-radius: 100px !important;
    border: 1px solid rgb(184, 223, 255) !important;
    padding: 0px 12.3px !important;
    text-transform: capitalize !important;
    width: 120px;
    max-width: 120px;
}
@media only screen and (max-width: 768px) {
    .app-title.menu-btn-hide {
        padding-left: 13px!important;
    }
    .app-title.menu-btn-hide.menu-btn-show-admin {
        padding-left: 15px!important;
    }
}
@media only screen and (max-width: 570px){
    .product-name{
        display: none !important;
    }
}
.dropdownUser.dropdown-menu{
    border-bottom-left-radius: 15px !important;
    border-bottom-right-radius: 15px !important;
}
.logoutUser{
    box-shadow: 0 -3px 4px 0 rgba(0, 0, 0, 0.16);
    background-color: #e5e5e5;
    text-align: center;
    border-bottom-left-radius: 15px !important;
    border-bottom-right-radius: 15px !important;
}
.logoutUser.dropdown-item:hover{
    box-shadow: 0 -3px 4px 0 rgba(0, 0, 0, 0.16) !important;
    background-color: #e5e5e5 !important;
}
div.title.h6 {
    font-size: 14px;
    font-weight: 600;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.21;
    letter-spacing: 0.6px;
    color: #00448b;
}
.border-img {
    width: 202px;
    height: 2px;
    object-fit: contain;
    border-radius: 19px;
    padding-left: 10px;
    margin-bottom: 5px;
}
.headerproducts {
    padding: 5px 10px 0px 10px;
}
.viewtxt {
    font-size: 12px;
    font-weight: 600;
    line-height: 1.25;
    letter-spacing: 0.5px;
    color: #303031;
    padding-right: 6px;
}
.search-group {
    margin-bottom: 0px;
    padding: 10px 10px;
}
.input-search {
    position: relative;
}
.input-search .input-search-close, .input-search .input-search-icon {
    position: absolute;
    top: 50%;
    z-index: 1;
    width: 2.573rem;
    -webkit-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    -o-transform: translateY(-50%);
    transform: translateY(-50%);
}
.input-search .input-search-icon {
    left: 0px;
    font-size: 16px;
    color: #00448b;
    text-align: center;
    pointer-events: none;
    width: 16px;
    height: 16px;
    line-height: 16px;
}
.input-search .input-search-icon+.search-control {
    padding-left: 2.4rem;
}
.search-control:focus + .input-search .input-search-icon {
    color: #00448b !important;
}
.search-control {
    height: 2.573rem;
    -webkit-appearance: none;
    border-color: #00448b;
    -webkit-box-shadow: none;
    box-shadow: none;
    -webkit-transition: -webkit-box-shadow .25s linear,border .25s linear,color .25s linear,background-color .25s linear;
    -o-transition: box-shadow .25s linear,border .25s linear,color .25s linear,background-color .25s linear;
    transition: box-shadow .25s linear,border .25s linear,color .25s linear,background-color .25s linear;
    -moz-appearance: none;
}
.search-control {
    display: block;
    width: 100%;
    padding: .429rem 1.072rem;
    font-size: 14px;
    line-height: 1.571429;
    color: #303031;
    background-color: #fff;
    background-image: none;
    -webkit-background-clip: padding-box;
    background-clip: padding-box;
    border-bottom: 1px solid #cdd2da !important;
    border-radius: 0px;
    -webkit-transition: border-color ease-in-out .15s,-webkit-box-shadow ease-in-out .15s;
    -o-transition: border-color ease-in-out .15s,box-shadow ease-in-out .15s;
    transition: border-color ease-in-out .15s,box-shadow ease-in-out .15s;
    overflow: visible;
    margin: 0;
}
.search-control:focus {
    border-color: #00448b !important;
}
button.input-search-close {
    -webkit-appearance: none;
    padding: 0;
    cursor: pointer;
    background: 0 0;
    border: 0;
}
.input-search-close.icon {
    font-size: 16px;
    line-height: 16px;
}
.input-search .input-search-close {
    right: 8px;
}
.userWidth{
    width: 185px;
    max-width: 185px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
}
.dropdownUser.dropdown-menu{
    min-width: 33rem !important;
    padding: 0rem 0 !important;
    top: 5px !important;
    left: 22px !important;
}
.dropdown-toggle.dropdownhideafter::after {
  content: none !important;
}
.search-magnify{
    font-size: 19px;
    position: relative;
    right: 3px;
    outline: 0;
}
.box-shadow{
    box-shadow: none !important;
}
.margins{
    margin-bottom:10px;
    margin-top:10px !important;
}
.margin-align{
    margin-bottom:10px;
    margin-top:0px !important;
}
.min-wid{
    min-width: 17rem;
}
.profile-width{
    width: 3.5rem !important;
    min-width: 3.5rem !important;
    height: 3.5rem !important;
}
.max-width{
    max-width: 100px;
}
.profile-avatar{
    width: 40px;
    height: 40px;
}
.username{
    letter-spacing: 0.04rem;
}
.isp-active{
    width: 50px;
    border-radius: 7px;
    padding-left: 14px;
    padding-top: 2px;
    padding-bottom: 2px;
    padding-right: 5px;
    font-size: 16px;
    background: #25bb83;
    border: solid 1px #cdd2da;
    font-weight: 500;
}
.profile-pic{
    position: relative;
    bottom: 3px;
}
.rotate-180{
    transform: rotate(180deg);
}
.bg-light-grey{
    background: #f5f6f9;
}
.menu-transit{
    transition: 0.2s ease all;
    height: 103px;
}
.h-58{
    height: 58px !important;
    transition: 0.2s ease all;
}
.animated {
    -webkit-animation-duration: 0.2s;animation-duration: 0.2s;
    -webkit-animation-fill-mode: both;animation-fill-mode: both;
}

@-webkit-keyframes fadeOut {
    0% {opacity: 0;}
    100% {opacity: 1;}
}

@keyframes fadeOut {
    0% {opacity: 0;}
    100% {opacity: 1;}
}

.fadeOut {
    -webkit-animation-name: fadeOut;
    animation-name: fadeOut;
    z-index: 9999;
}
.activate-scanner{
    position: relative;
    top: 4px;
    right: 10px;
}
.search-data{
    padding-left: 8px !important;
    padding-right: 8px !important;
    padding-bottom: 8px !important;
    padding-top: 8px !important;
}
.select-options {
  display: none;
}
@media (max-width: 1320px) {
    .nav-options    { display: none !important; }
    .select-options { display: inline-block; }
    .mr-4rem{
        margin-right: 1.2rem !important;
    }
}
.dropdown-requests {
    width: 420px;
    min-height: 100px;
    max-height: 390px;
    margin: 0.25rem 0 0 !important;
    overflow-y: auto;
    top: 10px !important;
    border-radius: 11px !important;
    padding: 0rem 0 !important;
    position: absolute;
    right: 1px;
    left: -9px !important;
    z-index: 99;
    cursor: pointer;
    box-shadow: -5px 5px 7px 0 rgba(0, 0, 0, 0.16);
    background-color: #ffffff;
}
.notifyheader {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    min-height: 40px;
    height: 100%;
    position: relative;
    background: #f1f8fc;
    -webkit-box-shadow: none;
    box-shadow: none;
}

.notifyheader>.descriptionheader {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    padding: 16px;
    border-bottom: 1px solid #cdd2da;
}

.notifyheader>.descriptionheader .description-text-header-left h5 {
    font-size: 14px;
    font-weight: 600;
    margin: 0;
    color: #808495;
}

.notifyheader>.descriptionheader .description-text-header-right {
    font-size: 13px;
    margin-left: auto;
    padding-left: 12px;
    color: #00448b;
    font-weight: 500;
}

.notifyheader>.descriptionheader .description-text-header-right {
    display: block;
}

.profileheader {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    min-height: 40px;
    position: relative;
    background: #FFFFFF;
    -webkit-box-shadow: none;
    box-shadow: none;
}

.profileheader>.descriptionheader {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    padding: 6px 10px;
    border-bottom: 1px solid transparent;
}

.profileheader>.descriptionheader .description-text-header-left h5 {
    font-size: 13px;
    font-weight: 600;
    margin: 0;
}

.profileheader>.descriptionheader .description-text-header-right {
    font-size: 13px;
    margin-left: auto;
    padding-left: 12px;
    color: #00448b;
    font-weight: 500;
}

.profileheader>.descriptionheader .description-text-header-right {
    display: block;
}

/* .profileheader>.descriptionheader .description-text-header-right span {
width: 26px !important;
height: 26px;
line-height: 28px;
background: #f5f6f9;
border-radius: 50%;
text-align: center;
display: block;
cursor: pointer;
} */
.profileheader>.descriptionheader .description-text-header-right span {
    background: transparent;
    border-radius: none;
    text-align: center;
    display: block;
    cursor: pointer;
}

.profileheader>.descriptionheader .description-text-header-right span i {
    font-size: 17px;
    width: 17px !important;
    height: 17px;
    line-height: 17px;
    color: #00448b;
}

.dropdown-menu-header {
    position: relative;
    padding: 20px 20px;
    background-color: #fff;
    border-bottom: 1px solid #e0e0e0;
}

.dropdown-menu-header>h5 {
    margin: 0;
}

.dropdown-menu-header .badge {
    position: absolute;
    top: 50%;
    right: 20px;
    -webkit-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    -o-transform: translateY(-50%);
    transform: translateY(-50%);
}

.countnotification {
    position: absolute;
    bottom: 3.3rem;
    right: 0.4rem;
    color: #fff !important;
    background: #ff9a06;
    width: 16px;
    height: 16px;
    line-height: 16px;
    border-radius: 50%;
    font-size: 10px;
    font-weight: 600;
}

.list-group.profile-group .list-group-item.three-line {
    min-height: 6.8rem;
    border-bottom: 1px solid #cdd2da;
}

.list-group.profile-group .list-group-item.three-line:last-child {
    border-bottom: 1px solid transparent;
    margin-bottom: 25px;
}

.list-group.profile-group .list-group-item:hover,
.list-group.profile-group .list-group-item:focus {
    z-index: 0;
    text-decoration: none;
}

.list-group.profile-group .list-group-item h3 {

    font-size: 14px !important;
    font-weight: 600 !important;
    line-height: 1.21;
    letter-spacing: 0.6px;
    color: #303031 !important;
    margin: 0;
}

.list-group.profile-group .list-group-item h4 {
    font-size: 14px;
    font-weight: 500;
    line-height: 1.21;
    letter-spacing: 0.6px;
    color: #4e5764 !important;
}

.list-group.profile-group .list-group-item p.compname {
    font-size: 13px;
    font-weight: 500;
    line-height: 1.21;
    letter-spacing: 0.6px;
    color: #00448b !important;
}

.profile-selected.no-accounts {
    position: relative;
    margin-bottom: 44px;
}

.profile-selected .list-group .list-group-item h3 {
    font-size: 12px !important;
    font-weight: 600 !important;
    line-height: 1.21;
    letter-spacing: 0.6px;
    color: #303031 !important;
    margin: 0;
}

.profile-selected .list-group .list-group-item p {
    font-size: 12px;
    font-weight: 500;
    line-height: 1.21;
    letter-spacing: 0.6px;
    color: #4e5764 !important;
    padding-top: 7px;
}

.btn-personal {
    height: 28px !important;
    padding: 0 12px !important;
    border-radius: none !important;
    font-size: 13px !important;
    line-height: 28px !important;
    text-transform: none !important;
    font-weight: 600 !important;
    text-decoration: none !important;
}

.btn-logout {
    height: 28px !important;
    padding: 0 18px !important;
    border-radius: 18px !important;
    font-size: 12px !important;
    line-height: 28px !important;
    text-transform: none !important;
    font-weight: 600 !important;
}

.profilefooter {
    height: 45px;
    box-shadow: none;
    background-color: #f1f8fc;
    line-height: 45px;
    font-size: 12px;
    font-weight: bold;
    letter-spacing: 0.51px;
    color: #4e5764;
    display: block;
    position: absolute;
    bottom: 0px;
    width: 100%;
}

.profilefooter:hover {
    color: #00448b;
}

.grey-border-box {
    border: dashed 1px #cdd2da;
    padding: 11px 20px;
    font-size: 13px;
    font-weight: 600;
    line-height: 1.92;
    letter-spacing: 0.56px;
    text-align: center;
    color: #9e9e9e;
    width: 265px;
    margin: 0 auto;
    border-radius: 12px;
}

.search-user-company-blocks {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-flex-wrap: wrap;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    width: 100%;
}

.productSearch .contact .search-user-company-blocks .mailtext,
.productSearch .contact .search-user-company-blocks .user-company-name {
    width: 190px;
}

.nav-tabs .nav-link.subnav-tabs {
    color: #303031;
    background-color: transparent;
    border-bottom: 1.5px solid #cdd2da;
}

.nav-tabs .nav-link.subnav-tabs.active {
    color: #00448b;
    background-color: transparent;
    border-bottom: 1.5px solid #00448b;
}

@media only screen and (max-width: 874px) {
    .dropdown-submenu .dropdown-menu {
        top: 6px !important;
        left: 34% !important;
    }
}

@media only screen and (max-width: 939px) {
    .dropdown-submenu .dropdown-menu {
        left: 95px !important;
    }
}
.dropdown-search {
    width: 420px;
    min-height: 100px;
    max-height: 390px;
    margin: 0.25rem 0 0 !important;
    overflow-y: auto;
    top: 10px !important;
    border-radius: 11px !important;
    padding: 0rem 0 !important;
    position: absolute;
    right: 1px;
    left: -9px !important;
    z-index: 99;
    cursor: pointer;
    box-shadow: -5px 5px 7px 0 rgba(0, 0, 0, 0.16);
    background-color: #ffffff;
}
.avatar.avatar-grey {
    background-color: #cdd2da;
    font-size: 16px !important;
    font-weight: 600 !important;
    letter-spacing: 0.28px;
    color: #ffffff;
    width: 20px !important;
    min-width: 20px !important;
    height: 20px !important;
    line-height: 20px !important;
}

.input-search-rounded-box {
    position: relative;
}

.input-search-rounded-box .input-search-close,
.input-search-rounded-box .input-search-icon {
    position: absolute;
    top: 50%;
    z-index: 1;
    width: 2.573rem;
    -webkit-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    -o-transform: translateY(-50%);
    transform: translateY(-50%);
}

.input-search-rounded-box .input-search-icon {
    left: 8px;
    font-size: 16px;
    color: #9e9e9e;
    text-align: center;
    pointer-events: none;
}

.input-search-rounded-box .input-search-icon+.form-control {
    padding-left: 38px !important;
}

.input-search-rounded-box .form-control {
    border-radius: 200px !important;
}

.input-search-close.icon {
    font-size: inherit !important;
    line-height: inherit !important;
}

button.input-search-close {
    -webkit-appearance: none !important;
    padding: 0 !important;
    cursor: pointer !important;
    background: 0 0 !important;
    border: 0 !important;
}

.input-search-rounded-box .input-search-close {
    right: 8px !important;
    color: #cdd2da !important;
    font-size: 19px !important;
    width: 18px !important;
    height: 18px !important;
    line-height: 18px !important;
}

.input-search-rounded-box .form-control {
    height: 3.573rem !important;
    -webkit-appearance: none !important;
    border-color: #e0e0e0 !important;
    -webkit-box-shadow: none !important;
    box-shadow: none !important;
    -webkit-transition: -webkit-box-shadow .25s linear, border .25s linear, color .25s linear, background-color .25s linear !important;
    -o-transition: box-shadow .25s linear, border .25s linear, color .25s linear, background-color .25s linear !important;
    transition: box-shadow .25s linear, border .25s linear, color .25s linear, background-color .25s linear !important;
    -moz-appearance: none !important;
}

.input-search-rounded-box .form-control {
    display: block !important;
    width: 100% !important;
    padding: .429rem 1.072rem !important;
    font-size: 14px !important;
    line-height: 1.571429 !important;
    color: #4e5764 !important;
    background-color: #fff !important;
    -webkit-background-clip: padding-box !important;
    background-clip: padding-box;
    border: solid 1px #d5d5d5 !important;
    background-image: -webkit-gradient(linear, left top, left bottom, from(#efefef), color-stop(25%, #ffffff), color-stop(48%, #ffffff), color-stop(78%, #ffffff), to(#efefef)) !important;
    background-image: linear-gradient(to bottom, #efefef, #ffffff 25%, #ffffff 48%, #ffffff 78%, #efefef) !important;
}

.searchfooter {
    height: 40px;
    background-color: #f1f8fc;
    line-height: 40px;
    font-size: 12px;
    font-weight: bold;
    letter-spacing: 0.51px;
    color: #fff;
    display: block;
    position: absolute;
    bottom: 0px;
    width: 100%;
}

.searchfooter:hover {
    color: #fff !important;
}
.dropdown-profiles {
    width: 400px !important;
    min-height: 100px;
    max-height: 490px !important;
    margin: 0.25rem 0 0 !important;
    overflow-y: auto;
    top: 16px !important;
    border-radius: 11px !important;
    padding: 0rem 0 !important;
    position: absolute;
    right: 1px;
    left: -10px !important;
    z-index: 2;
    cursor: pointer;
    box-shadow: -5px 5px 7px 0 rgba(0, 0, 0, 0.16);
    background-color: #ffffff;
}

@media screen and (max-width: 429px) {
    .dropdown-profiles {
        width: 350px !important;
        margin: 0.25rem 13rem 0 !important;
    }
}
.pointer-events-none {
    /* pointer-events: none; */
    cursor: not-allowed !important;
}
.settings-icon {
    top:58px;
    right:29px;
    padding: 4.1px 4px 4.1px 4.3px;
    border-radius: 2px;
    /* border: solid 0.5px #00448b;
    background-color: #00448b; */
}
.switch-user-prpfile {
    border-radius: 50%;
    border: 0px solid #ecf1f9;
    width: 75px;
    height: 75px;
}
.company-list {
    border: solid 0.2px rgba(128, 132, 149, 0.05);
    background-color: rgba(13, 91, 230, 0.05);
}
.overflow-height {
    max-height: 335px;
    min-height: auto;
    overflow-y: auto;
    -ms-overflow-style: none;  /* IE and Edge */
    scrollbar-width: none;  /* Firefox */

}
.overflow-heighst ::-webkit-scrollbar {
    display: none;
}
/* .overflow-height  {
  -ms-overflow-style: none;
  scrollbar-width: none;
} */

.search-dropdown {
    display: flex;
    will-change: transform;
    animation: menu-sub-dropdown-animation-fade-in 0.3s ease 1, menu-sub-dropdown-animation-move-up 0.3s ease 1;
    border-radius: 0.475rem;
    background-color: #fff;
    box-shadow: 0px 0px 50px 0px rgba(82, 63, 105, 0.15);
    list-style: none;
    flex-direction: column;
}
.w-md-375px {
    width: 400px !important;
}
.position-relative {
    position: relative !important;
}
.position-absolute {
    position: absolute !important;
}
.top-50 {
    top: 50% !important;
}
.translate-middle-y {
    transform: translateY(-50%) !important;
}
.ms-0 {
    margin-left: 0 !important;
}
.me-0 {
    margin-right: 0 !important;
}
.svg-icon {
    line-height: 1;
    color: #A1A5B7;
}
.svg-icon.svg-icon-lg-1 svg {
    height: 1.75rem !important;
    width: 1.75rem !important;
}
.form-search-control {
    display: block;
    width: 100%;
    padding: 0.775rem 1rem;
    font-size: 1.1rem;
    font-weight: 500;
    line-height: 1.5;
    color: #5E6278;
    background-color: #ffffff;
    background-clip: padding-box;
    border: 1px solid #E4E6EF;
    appearance: none;
    border-radius: 0.475rem;
    box-shadow: inset 0 1px 2px rgb(0 0 0 / 8%);
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
.ps-10 {
    padding-left: 2.5rem !important;
}
.form-search-control.form-control-flush {
    border: 0;
    background-color: transparent;
    outline: none !important;
    box-shadow: none;
    border-radius: 0;
}
.end-0 {
    right: 0 !important;
}
.lh-0 {
    line-height: 0 !important;
}
.closebtn {
    color: #181C32;
    background: transparent;
    border-color: transparent;
    outline: none !important;
}
.closebtn.btn-flush {
    appearance: none;
    box-shadow: none;
    border-radius: 0;
    border: none;
    cursor: pointer;
    background-color: transparent;
    outline: none !important;
    margin: 0;
    padding: 0;
}
.closebtn .svg-icon {
    flex-shrink: 0;
    line-height: 0;
    margin-right: 0.5rem;
}
.separator {
    display: block;
    height: 0;
    border-bottom: 1px solid #eff2f5;
}
.borderBottom {
    border-bottom: 1px solid #eff2f5;
}
.flex-stack {
    justify-content: space-between;
    align-items: center;
}
.fw-semibold {
    font-weight: 500 !important;
}
.text-muted {
    color: #A1A5B7 !important;
}
.fs-6 {
    font-size: 13px !important;
}
.me-2 {
    margin-right: 0.5rem !important;
}
.scroll-y {
    overflow-y: scroll;
    position: relative;
}
.mh-200px {
    max-height: 200px !important;
}
@media (min-width: 992px) {
    .mh-lg-325px {
        max-height: 325px !important;
    }
}
.imageSymbol {
    display: inline-block;
    flex-shrink: 0;
    position: relative;
    border-radius: 0.475rem;
}
.me-4 {
    margin-right: 1rem !important;
}

.imageSymbol .imageSymbol-label {
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 500;
    color: #3F4254;
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
    border-radius: 0.475rem;
}
.imageSymbol.imageSymbol-40px .imageSymbol-label {
    width: 40px;
    height: 40px;
}
.imgAvatar {
    width: 40px;
}
.flex-column {
    flex-direction: column !important;
}
.fw-semibold {
    font-weight: 500 !important;
}
.text-hover-primary {
    transition: color 0.2s ease;
}
.text-hover-primary:hover {
    transition: color 0.2s ease;
    color: #00448b !important;
}
.text-gray-800 {
    color: #303031 !important;
}
.text-decoration-none {
    text-decoration: none;
}
.opacity-50 {
    opacity: 0.5 !important;
}
.svg-icon.svg-icon-4x svg {
    height: 4rem !important;
    width: 4rem !important;
}
.mw-300 {
    max-width: 300px !important;
}
.section-hover:hover{
    background-color: #f7f7f7 !important;
}

.scroller{
    overflow: auto !important;
    max-height:250px;
}
.search-custom.el-dropdown-menu__item{
    line-height: 25px !important;
    padding: 0 5px !important;
}
.notification-count{
    background-color: rgb(199, 51, 51);
    width: 20px;
    position: absolute;
    border-radius: 100%;
    right: 0px;
    bottom: 22px;
    height: 20px;
    font-size: 11px;
    font-weight: 600;
    line-height: 20px;
}
.lh-30px{
    line-height: 30px;
}
.lh-24px{
    line-height: 24px;
}
.search-custom-note.el-dropdown-menu__item{
    line-height: 25px !important;
    padding: 2px 10px !important;
    border-radius: 6px !important;
}
.search-custom-note{
    background: #e1e7ee !important;
}
.search-custom-note.selected{
    background-color: #fff !important
}
.search-custom-note.selected:hover{
    background-color: transparent !important;
    border-radius: 0px !important;
}
.margin-auto-img{
    margin: auto;
    display: block;
}
.text-grey{
    color:#e4e4e4 !important;
}

.notify-loader{
    position: absolute;
    top: 75% !important;
    margin: 0 auto;
    width: 100%;
}
.messageText {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    width: 325px;
}
.admin-width{
    width: 450px;
    max-height: 528px;
    border-radius: 10px !important;
    background-color: #f3f6fb !important;
    box-shadow: 0 2px 0px 0 rgb(0 0 0 / 10%);
    position: absolute;
    right: 8px;
    left: auto;
    top: 100%;
    margin-top: 5px;
    z-index: 11;
    color: #000000;
    padding: 10px 0;
}
.dropdown-width-responsive{
    background-color: #fff;
    border-radius: 10px;
    max-height: 472px;
    margin-left: 15px !important;
    margin-right: 15px !important;
    padding-bottom: 10px;
}
.list-dropdown {
  height: 50px;
  padding: 21px 15px 20.9px 13px;
  border-radius: 0px;
  border: solid 0.3px #ebebeb !important;
  background-color: #faf8f8;
  margin-top: -2px;
}
.main-dropdown {
  border-radius: 5px;
  border: solid 1px #ebebeb;
  background-color: #f7f7f7;
  height: 50px;
  margin-bottom: -7px;
  margin-top: 0px;
}
.main-dropdown.br-t-r-5 {
    border-radius: 5px 5px 0px 0px;
}
.main-dropdown.subcompany-dropdown {
    height: 58px;
}
.setting-align{
    width: 28px;
    margin-top: -65px;
    margin-left: 352px;
    cursor: pointer;
}
.btn-size{
    width: 110px;
    padding: 0 10px !important;
    margin-left: 280px !important;
    margin-top: -36px !important;
}
.btn-secondary{
    border-radius: 12px !important;
}
.background-default{
    background-color: #fff;
    border: solid 1px #fff !important;
}
.open-dropdown{
    border-radius: 5px 5px 0 0;
    border: solid 0.3px #ebebeb;
    height: 50px;
    margin-bottom: -7px;
    margin-top: 5px;
    background-color: #fff;
}
.avatar {
    width: 3rem;
    min-width: 3rem;
    height: 3rem;
    line-height: 4rem;
    -webkit-border-radius: 50%;
    border-radius: 50%;
    font-size: 1.7rem;
    font-weight: 500;
    text-align: center;
    color: #FFFFFF;
    background-color: #fff;
}
.green-active-org {
    background-color: #008b29;
}
.navbar-avatar {
    border-radius: 50% !important;
    font-family: 'Poppins', sans-serif !important;
}
.navbar-avatar span {
    margin-top: 3px;
    font-weight: 500;
    font-size: 21px;
}
.navbar-avatar.navbar-avatar-small span{
    margin-top: 2px;
    font-weight: 500;
    font-size: 16px;
}
.org-icon-rotate-transition {
    font-size: 24px;
    width: 24px;
    height: 24px;
    line-height: 20px;
    transition: all 0.3s;
}
.org-icon-rotate-down {
    transform: rotate(180deg);
}
.hide-on-mob-screen {
    display: block
}
.show-on-mob-screen {
    display: none;
}
.not-selected{
    color: #3f3f3f;
}
.switch-company-backdrop {
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    z-index: 9;
    background-color: rgba(0, 0, 0, 0.16);
}
@media screen and (max-width: 450px) {
    .admin-width {
        position: fixed;
        top: 50px;
        right: 0;
        left: 0;
        width: 100%;
    }
    .hide-on-mob-screen {
        display: none;
    }
    .show-on-mob-screen {
        display: block;
    }
    .admin-width {
        max-height: 580px;
    }
    .dropdown-width-responsive {
        max-height: 530px;
    }
}
@media screen and (max-width: 316px) {
    .isp-active {
        display: none;
    }
}
@media only screen and (min-width: 901px){
    .minimize-menu{
        display: none;
    }
    .align{
        display: none;
    }
    .user-menu-align{
        display: none;
    }
    .digi-logo{
        display: none;
    }
}
@media only screen and (min-width: 0px) and (max-width: 350px){
    .avtr-padding{
        padding-right: 6px;
        padding-left: 6px;
    }
    .minimize-menu{
        font-size: 12px;
        color: #fff;
        z-index: 999;
        /* margin-left: 30px; */
    }
    .user-menu-align{
        text-align: right;
        margin-left: 20%;
    }
    .notification{
        display: none;
    }
    .products{
        display: none;
    }
    .time{
        display: none;
    }
    .time-align{
        margin-left: -10px;
    }
    .submenu-align{
        margin-left: -5% !important;
        margin-top: 5px;
        margin-bottom: -15px !important;
    }
    .notificn{
        margin-top: -8px !important;
    }
    .background-dots {
        background-color: #005dae;
        width: 100%;
        visibility: 999;
        border-radius: 50%;
    }
    .dots-vertical{
        color: #fff !important;
        padding-left: 2px !important;
        padding-right: 2px !important;
        padding-top: 5px;
        padding-bottom: 4px;
    }
    .logo-digi{
        display: none;
    }
    .menu{
        margin-right: -10px !important;
    }
    .notification-dropdown{
        width: 300px;
        min-width: 300px;
    }
    .products-button {
        height: 30px !important;
        line-height: 30px !important;
        border-radius: 100px !important;
        border: 1px solid rgb(184, 223, 255) !important;
        padding: 0px 5.3px !important;
        text-transform: capitalize !important;
        width: 102px;
        margin-left: 0px;
    }
    .nav-bar-digi{
        display: none;
    }
    .hidebuttons{
        display: none;
    }
}
@media only screen and (min-width:351px) and (max-width: 400px){
    .avtr-padding{
        padding-right: 6px;
        padding-left: 6px;
    }
    .minimize-menu{
        font-size: 12px;
        color: #fff;
        margin-left: 30px;
        z-index: 999;
    }
    .user-menu-align{
        text-align: right;
        margin-left: 25% !important;
    }
    .notification{
        display: none;
    }
    .products{
        display: none;
    }
    .time{
        display: none;
    }
    .time-align{
        margin-left: -10px;
    }
    .submenu-align{
        margin-left: -5% !important;
        margin-top: 5px;
        margin-bottom: -15px !important;
    }
    .notificn{
        margin-top: -8px !important;
    }
    .background-dots {
        background-color: #005dae;
        width: 100%;
        visibility: 999;
        border-radius: 50%;
    }
    .dots-vertical{
        color: #fff !important;
        padding-left: 2px !important;
        padding-right: 2px !important;
        padding-top: 5px;
        padding-bottom: 4px;
    }
    .logo-digi{
        display: none;
    }
    .menu{
        margin-right: -10px !important;
    }
    .notification-dropdown{
        width: 360px;
        min-width: 360px;
    }
    .products-button {
        height: 30px !important;
        line-height: 30px !important;
        border-radius: 100px !important;
        border: 1px solid rgb(184, 223, 255) !important;
        padding: 0px 5.3px !important;
        text-transform: capitalize !important;
        width: 102px;
        margin-left: 0px;
    }
    .nav-bar-digi{
        display: none;
    }
    .hidebuttons{
        display: none;
    }
}
@media only screen and (min-width:401px) and (max-width: 567px){
    .avtr-padding{
        padding-right: 6px;
        padding-left: 6px;
    }
    .minimize-menu{
        font-size: 12px;
        color: #fff;
        z-index: 999;
        margin-left: 30px;
    }
    .user-menu-align{
        text-align: right;
        margin-left: 38% !important;
    }
    .notification{
        display: none;
    }
    .products{
        display: none;
    }
    .time{
        display: none;
    }
    .time-align{
        margin-left: -10px;
    }
    .submenu-align{
        margin-left: -5% !important;
        margin-top: 5px;
        margin-bottom: -15px !important;
    }
    .notificn{
        margin-top: -8px !important;
    }
    .background-dots {
        background-color: #005dae;
        width: 100%;
        visibility: 999;
        border-radius: 50%;
    }
    .dots-vertical{
        color: #fff !important;
        padding-left: 2px !important;
        padding-right: 2px !important;
        padding-top: 5px;
        padding-bottom: 4px;
    }
    .logo-digi{
        display: none;
    }
    .menu{
        margin-right: -10px !important;
    }
    .notification-dropdown{
        width: 380px;
        min-width: 380px;
    }
    .products-button {
        height: 30px !important;
        line-height: 30px !important;
        border-radius: 100px !important;
        border: 1px solid rgb(184, 223, 255) !important;
        padding: 0px 5.3px !important;
        text-transform: capitalize !important;
        width: 102px;
        margin-left: 0px;
    }
    .nav-bar-digi{
        display: none;
    }
    .hidebuttons{
        display: none;
    }
}
@media only screen and (min-width:568px) and (max-width: 599px){
    .avtr-padding{
        padding-right: 6px;
        padding-left: 6px;
    }
    .minimize-menu{
        font-size: 12px;
        color: #fff;
        z-index: 999;
        margin-left: 30px;
    }
    .user-menu-align{
        text-align: right;
        margin-left: 56% !important;
    }
    .notification{
        display: none;
    }
    .products{
        display: none;
    }
    .time{
        display: none;
    }
    .time-align{
        margin-left: -10px;
    }
    .submenu-align{
        margin-left: -5% !important;
        margin-top: 5px;
        margin-bottom: -15px !important;
    }
    .notificn{
        margin-top: -8px !important;
    }
    .background-dots {
        background-color: #005dae;
        width: 100%;
        visibility: 999;
        border-radius: 50%;
    }
    .dots-vertical{
        color: #fff !important;
        padding-left: 2px !important;
        padding-right: 2px !important;
        padding-top: 5px;
        padding-bottom: 4px;
    }
    .logo-digi{
        display: none;
    }
    .menu{
        margin-right: -10px !important;
    }
    .notification-dropdown{
        width: 420px;
        min-width: 420px;
    }
    .products-button {
        height: 30px !important;
        line-height: 30px !important;
        border-radius: 100px !important;
        border: 1px solid rgb(184, 223, 255) !important;
        padding: 0px 5.3px !important;
        text-transform: capitalize !important;
        width: 102px;
        margin-left: 0px;
    }
    .nav-bar-digi{
        display: none;
    }
    .hidebuttons{
        display: none;
    }
}
@media only screen and (min-width:600px) and (max-width: 620px){    
    .avtr-padding{
        padding-right: 6px;
        padding-left: 6px;
    }
    .minimize-menu{
        font-size: 12px;
        color: #fff;
        z-index: 999;
        margin-left: 30px;
    }
    .user-menu-align{
        text-align: right;
        margin-left: 58% !important;
    }
    .notification{
        display: none;
    }
    .products{
        display: none;
    }
    .time{
        display: none;
    }
    .time-align{
        margin-left: -10px;
    }
    .submenu-align{
        margin-left: -5% !important;
        margin-top: 5px;
        margin-bottom: -15px !important;
    }
    .notificn{
        margin-top: -8px !important;
    }
    .background-dots {
        background-color: #005dae;
        width: 100%;
        visibility: 999;
        border-radius: 50%;
    }
    .dots-vertical{
        color: #fff !important;
        padding-left: 2px !important;
        padding-right: 2px !important;
        padding-top: 5px;
        padding-bottom: 4px;
    }
    .logo-digi{
        display: none;
    }
    .menu{
        margin-right: -10px !important;
    }
    .notification-dropdown{
        width: 420px;
        min-width: 420px;
    }
    .products-button {
        height: 30px !important;
        line-height: 30px !important;
        border-radius: 100px !important;
        border: 1px solid rgb(184, 223, 255) !important;
        padding: 0px 5.3px !important;
        text-transform: capitalize !important;
        width: 102px;
        margin-left: 0px;
    }
    .nav-bar-digi{
        display: none;
    }
    .hidebuttons{
        display: none;
    }
}
@media only screen and (min-width:621px) and (max-width: 668px){
    
    .avtr-padding{
        padding-right: 6px;
        padding-left: 6px;
    }
    .minimize-menu{
        font-size: 12px;
        color: #fff;
        z-index: 999;
        margin-left: 30px;
    }
    .user-menu-align{
        text-align: right;
        margin-left: 60% !important;
    }
    .notification{
        display: none;
    }
    .products{
        display: none;
    }
    .time{
        display: none;
    }
    .time-align{
        margin-left: -10px;
    }
    .submenu-align{
        margin-left: -5% !important;
        margin-top: 5px;
        margin-bottom: -15px !important;
    }
    .notificn{
        margin-top: -8px !important;
    }
    .background-dots {
        background-color: #005dae;
        width: 100%;
        visibility: 999;
        border-radius: 50%;
    }
    .dots-vertical{
        color: #fff !important;
        padding-left: 2px !important;
        padding-right: 2px !important;
        padding-top: 5px;
        padding-bottom: 4px;
    }
    .logo-digi{
        display: none;
    }
    .menu{
        margin-right: -10px !important;
    }
    .notification-dropdown{
        width: 420px;
        min-width: 420px;
    }
    .products-button {
        height: 30px !important;
        line-height: 30px !important;
        border-radius: 100px !important;
        border: 1px solid rgb(184, 223, 255) !important;
        padding: 0px 5.3px !important;
        text-transform: capitalize !important;
        width: 102px;
        margin-left: 0px;
    }
    .nav-bar-digi{
        display: none;
    }
    .hidebuttons{
        display: none;
    }
}
@media only screen and (min-width:669px) and (max-width: 768px){
    .avtr-padding{
        padding-right: 6px;
        padding-left: 6px;
    }
    .minimize-menu{
        font-size: 12px;
        color: #fff;
        z-index: 999;
        margin-left: 30px;
    }
    .user-menu-align{
        text-align: right;
        margin-left: 65% !important;
    }
    .notification{
        display: none;
    }
    .products{
        display: none;
    }
    .time{
        display: none;
    }
    .time-align{
        margin-left: -10px;
    }
    .submenu-align{
        margin-left: -5% !important;
        margin-top: 5px;
        margin-bottom: -15px !important;
    }
    .notificn{
        margin-top: -8px !important;
    }
    .background-dots {
        background-color: #005dae;
        width: 100%;
        visibility: 999;
        border-radius: 50%;
    }
    .dots-vertical{
        color: #fff !important;
        padding-left: 2px !important;
        padding-right: 2px !important;
        padding-top: 5px;
        padding-bottom: 4px;
    }
    .logo-digi{
        display: none;
    }
    .menu{
        margin-right: -10px !important;
    }
    .notification-dropdown{
        width: 420px;
        min-width: 420px;
    }
    .products-button {
        height: 30px !important;
        line-height: 30px !important;
        border-radius: 100px !important;
        border: 1px solid rgb(184, 223, 255) !important;
        padding: 0px 5.3px !important;
        text-transform: capitalize !important;
        width: 102px;
        margin-left: 0px;
    }
    .nav-bar-digi{
        display: none;
    }
    .hidebuttons{
        display: none;
    }
}
@media only screen and (min-width:769px) and (max-width: 900px){
    .minimize-menu{
        font-size: 12px;
        color: #fff;
        z-index: 999;
        margin-left: 30px;
    }
    .user-menu-align{
        text-align: right;
        margin-left: 65% !important;
    }
    .notification{
        display: none;
    }
    .products{
        display: none;
    }
    .time{
        display: none;
    }
    .time-align{
        margin-left: -10px;
    }
    .submenu-align{
        margin-left: -5% !important;
        margin-top: 5px;
        margin-bottom: -15px !important;
    }
    .notificn{
        margin-top: -8px !important;
    }
    .background-dots {
        background-color: #005dae;
        width: 100%;
        visibility: 999;
        border-radius: 50%;
    }
    .dots-vertical{
        color: #fff !important;
        padding-left: 2px !important;
        padding-right: 2px !important;
        padding-top: 5px;
        padding-bottom: 4px;
    }
    .logo-digi{
        display: none;
    }
    .menu{
        margin-right: -10px !important;
    }
    .notification-dropdown{
        width: 420px;
        min-width: 420px;
    }
    .products-button {
        height: 30px !important;
        line-height: 30px !important;
        border-radius: 100px !important;
        border: 1px solid rgb(184, 223, 255) !important;
        padding: 0px 5.3px !important;
        text-transform: capitalize !important;
        width: 102px;
        margin-left: 0px;
    }
    .nav-bar-digi{
        display: none;
    }
    .hidebuttons{
        display: none;
    }
}
@media only screen and (min-width:901px) and (max-width: 1180px){
    .isp-active{
        display: none;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/Navbar.vue